import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { 
  Affix,
  Breadcrumb,
  Button,
  Col,
  Drawer,
  Flex,
  Form,
  Layout,
  message,
  Modal,
  notification,
  Popover,
  Row,
  Skeleton,
  Space,
  Spin,
  Tabs,
  Tooltip,
} from "antd";
import {
  mdiAccountCash,
  mdiAccountGroup,
  mdiAirplane,
  mdiBagChecked,
  mdiBedKing,
  mdiClose,
  mdiEmailOutline,
  mdiFileDownload,
  mdiFlagTriangle,
  mdiMapMarker,
  mdiMenuDown,
  mdiMenuUp,
  mdiPhoneInTalkOutline,
  mdiReceiptText,
  mdiShieldAccount,
  mdiShieldAirplane,
  mdiSilverwareForkKnife,
  mdiWhatsapp,
  mdiWifi,
  mdiHomeCity,
  mdiAccountMultiple,
  mdiFileDocument,
  mdiInformationOutline,
  mdiThumbUp,
  mdiChevronLeft,
  mdiChevronRight,
  mdiOfficeBuilding,
  mdiEarth,
  mdiAlertBox,
  mdiCheckboxMarkedCircleAutoOutline,
  mdiShareVariant,
} from "@mdi/js";
import Icon from "@mdi/react";
import Headline from "./Headline";
import { Content } from "antd/es/layout/layout";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { CruiseCabin, CruiseDeparture, CruiseRoomType, Itinerary, PaymentDetails, Tour, TourInclusions } from "../../interfaces/itinerary.interface";
import { format, parse } from "date-fns";
import SeriesApi from "../../api-services/series-api.service";
import AgentsApi from "../../api-services/agents-api.service";
import { Agent } from "../../interfaces/agent.interface";
import TourDateSelector from "../../components/shared/TourDateSelector";
import HomeLink from "../../widgets/HomeLink";
import Sider from "antd/es/layout/Sider";
import ContactAgentsForm from "../../components/shared/ContactAgentsForm";
import PricingSummary from "../../components/shared/PricingSummary";
import BookingSelection from "./b2c2b/BookingSelection";
import { PAYMENT_TERMS, priceTypes, pricingCategory } from "../../enums/pricing.enum";
import { DEPARTURE_FULL_LOCATION } from "../../enums/departure_location.enum";
import { addons, CRUISE_CATEGORY, currencyDisplay, defaultPassengerInfos, emailLink, formatDate, parseCurrencyString, scrollIntoView, storedArray$, summarizeFare, totalPrice, uniqBy, whatsappLink } from "../../utils/helpers";
import PriceDetails from "../../components/shared/PriceDetails";
import { BookingAddOns, BookingInput } from "../../interfaces/booking.interface";
import { PromotionDeduction, PromotionSummary } from "../../interfaces/promotion.interface";
import { buildPromotionPax, parsePromotionCalculation, PaxPriceItem } from "../../utils/promotions";
import B2C2BApi from "../../api-services/b2c2b-api.service";
import Cookies from "js-cookie";
import ItineraryDownloadLinks from "../../components/shared/ItineraryDownloadLinks";
import TourDateSelector2 from "../../components/shared/v2/TourDateSelector";
import TourDateSelectorV3 from "../../components/shared/v3/TourDateSelector";
import FlightScheduleV3 from "../../components/shared/v3/FlightScheduleV3";
import ItineraryImages from "../../components/shared/ItineraryImages";
import PriceTable from "../../components/shared/PriceTable";
import PriceChartV3 from "../../components/shared/v3/PriceChartV3";
import PromoBannerV3 from "../../components/shared/v3/PromoBannerV3";
import ShowPageSkeleton from "../../components/shared/v3/ShowPageSkeleton";
import DetailsSection from "../../components/shared/DetailsSection";
import BookingNoticeTab from "./BookingNoticeTab";
import { IconDocument } from "../../components/shared/icons";
import BookingFormV3 from "./BookingFormV3";
import ItineraryTab from "./ItineraryTab";
import PricingSummary2 from "../../components/shared/v2/PricingSummary";
import Travelers from "./Travelers";
import CruiseCabinSelector from "../../components/shared/v2/CruiseCabinSelector";
import CruiseTravelers from "./CruiseTravelers";
import CruiseCabinSelectorV3 from "../../components/shared/v3/CruiseCabinSelector";
import {
  CruiseCabinPax,
  findCabinDetail,
  flattenCabinsToTravelers,
  maxCabinsFor,
  newCabin,
  toCabinGroups,
  travelerCountsFrom,
} from "../../utils/cruise";
import { useAuth } from "../../services/AuthContext";
import ListApi, { SelectOption } from "../../api-services/list-api.service";
import useBreakpoint from "../../utils/useBreakpoint";
import useScrollLock from "../../utils/useScrollLock";
import { getActiveVersion } from "../../utils/layoutVersion";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


const customCookies = Cookies.withAttributes({ expires: 14 });

const breadcrumbs = [
  { title: <HomeLink/>},
];

const CARDS = ["visa", "mastercard"];
const layoutStyle = { overflow: "hidden" };
const siderStyle = { backgroundColor: "transparent" };

const inclusions = (inclusionsData: Itinerary["includings"], {departure_location, latest_tour_confirmation, insurance, insurance_zone, highlight, important_notice, guide_languages, guarantee_tour_leader_seat}: Tour, { fileUrl, fileCNUrl, category_star, insurancePolicyUrl: policyUrl, insuranceBenefitUrl: benefitUrl }: Itinerary, v2?:boolean, isMobile?: boolean, v3?: boolean): TourInclusions[] => {
  if (!inclusionsData) return [];

  const renderInsuranceContent = () => {
    if (v3) {
      return (
        <div className="insurance-content">
          {insurance_zone && <span className="insurance-zone">{insurance_zone}</span>}
          {(policyUrl || benefitUrl) && (
            <div className="insurance-actions">
              {policyUrl && (
                <Button size="small" className="insurance-btn" href={policyUrl} target="_blank" rel="noopener noreferrer">
                  <Icon path={mdiReceiptText} size="14px" /> Policy <Icon path={mdiChevronRight} size="12px" />
                </Button>
              )}
              {benefitUrl && (
                <Button size="small" className="insurance-btn" href={benefitUrl} target="_blank" rel="noopener noreferrer">
                  <Icon path={mdiShieldAccount} size="14px" /> Benefits <Icon path={mdiChevronRight} size="12px" />
                </Button>
              )}
            </div>
          )}
        </div>
      );
    }
    return (
      <span>
        {insurance_zone && (insurance_zone + (policyUrl || benefitUrl ? " - " : ""))}
        {policyUrl && <a href={policyUrl} target="_blank" rel="noopener noreferrer">Policy</a>}
        {policyUrl && benefitUrl && " | "}
        {benefitUrl && <a href={benefitUrl} target="_blank" rel="noopener noreferrer">Benefit</a>}
      </span>
    );
  };

  if(v2){
    const luggageDisplayedValue = (value) => !!value ? value : "TBA";
    const TRAVEL_INSURANCE_MEMO = "Effective from 15 July 2024, all travel insurance must activate in the TravelB2B platfrom within 30 days from the schedule departure date to entitle complimentary travel insurance. Please refer memo for details";
    const BAGGAGE_LUGGAGE_DETAILS = (
      <Space direction="vertical">
        <span>Hand Carry Weight: {luggageDisplayedValue(latest_tour_confirmation?.hand_carry_weight)} </span>
        <span>Hand Carry Quantity: {luggageDisplayedValue(latest_tour_confirmation?.hand_carry_quantity)} </span>
        <span>Check-in Luggage Weight (International): {luggageDisplayedValue(latest_tour_confirmation?.luggage_weight)} </span>
        <span>Check-in Luggage Quantity (International): {luggageDisplayedValue(latest_tour_confirmation?.luggage_quantity)} </span>
        <span>Check-in Luggage Weight (Domestic): {luggageDisplayedValue(latest_tour_confirmation?.domestic_luggage_weight)} </span>
        <span>Check-in Luggage Quantity (Domestic): {luggageDisplayedValue(latest_tour_confirmation?.domestic_luggage_quantity)} </span>
      </Space>
    )
  
    const ITINERARY_CONTENT = (
      <div>
        <span><a href={fileUrl} target="_blank" rel="noopener noreferrer">EN</a> | <a href={fileCNUrl} target="_blank" rel="noopener noreferrer">CN</a></span>
      </div>
    )

    const parseLanguage = (lang: string): string => {
      if (!lang) return "TBA";
      const lower = lang.toLowerCase();
      if (lower.includes("bilingual")) return "English / Mandarin";
      if (lower.includes("english")) return "English";
      if (lower.includes("chinese") || lower.includes("mandarin")) return "Mandarin";
      return lang;
    };

    const parsedLanguage = parseLanguage(guide_languages);

    const DUPLICATE_INCLUSIVE_KEYS = ['group_departure', 'luggage'];

    const TOUR_INCLUSIVE_CONTENT = (
      <div className="tour-inclusive-caption">
        {Object.entries(inclusionsData)
          .filter(([key, val]) => !!val && !DUPLICATE_INCLUSIVE_KEYS.includes(key))
          .map(([key]) => key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase()))
          .join(", ")
        }
      </div>
    )

    const TOUR_LEADER_CONTENT = (
      <div className="tour-inclusive-caption">
        <span>{guarantee_tour_leader_seat === 0 ? "Included" : `Arrangement subject to a minimum group size of ${guarantee_tour_leader_seat} pax.`}</span>
      </div>
    )

    const STAR_RATING = category_star?.sort((a, b) => a - b).join("~") || "";

    return [
      {icon: <Icon path={mdiOfficeBuilding} size={'30px'} />  , label: `${STAR_RATING} Stars Hotel`, visible: !!STAR_RATING},
      {icon: <Icon path={mdiAirplane} size={'30px'} />  , label: "Departure", visible: true, content: () => <span>{DEPARTURE_FULL_LOCATION[departure_location] || departure_location}</span>},
      {icon: <Icon path={mdiFlagTriangle} size={'30px'} />, label: "Tour Leader", visible: guarantee_tour_leader_seat !== null && guarantee_tour_leader_seat !== undefined, content: () => TOUR_LEADER_CONTENT},
      {icon: <Icon path={mdiAccountMultiple} size={'30px'} />, label: "Group Departure", visible: inclusionsData.group_departure},
      {icon: <Icon path={mdiEarth} size={'30px'} />  , label: "Language", visible: true, content: () => <span>{parsedLanguage}</span>},
      {icon: <Icon path={mdiBagChecked} size={'30px'} />, label: "Baggage & Luggage", visible: inclusionsData.luggage, tooltip: BAGGAGE_LUGGAGE_DETAILS},
      {icon: <Icon path={mdiShieldAccount} size={'30px'} />, label: insurance, visible: !!insurance, content: renderInsuranceContent},
      {icon: <Icon path={mdiCheckboxMarkedCircleAutoOutline} size={'30px'} />  , label: "Tour Inclusive", visible: Object.entries(inclusionsData).some(([key, v]) => !!v && !DUPLICATE_INCLUSIVE_KEYS.includes(key)), content: () => TOUR_INCLUSIVE_CONTENT},
      {icon: <Icon path={mdiFileDocument} size={'30px'} />  , label: "Itinerary", content: () => ITINERARY_CONTENT, visible: !!fileUrl || !!fileCNUrl},
      {icon: <Icon path={mdiAlertBox} size={'30px'} />  , label: "Important Notice", visible: !!important_notice, tooltip: important_notice},
    ];
  }

  return [
    {icon: <Icon path={mdiShieldAccount} size={1} />, label: "Free Travel Insurance", visible: inclusionsData.acf, content: renderInsuranceContent},
    {icon: <Icon path={mdiReceiptText} size={1} />  , label: "Airport Taxes", visible: inclusionsData.airport_taxes},
    {icon: <Icon path={mdiFlagTriangle} size={1} />, label: guarantee_tour_leader_seat === 0 ? "Tour Leader" : `Tour Leader (min. group size ${guarantee_tour_leader_seat} pax)`, visible: guarantee_tour_leader_seat !== null && guarantee_tour_leader_seat !== undefined},
    {icon: <Icon path={mdiBagChecked} size={1} />, label: "Check-in Baggage", visible: inclusionsData.luggage},
    {icon: <Icon path={mdiSilverwareForkKnife} size={1} />, label: "Meal Onboard", visible: inclusionsData.meal_onboard},
    {icon: <Icon path={mdiBedKing} size={1} />, label: "Hotel", visible: inclusionsData.hotel},
    {icon: <Icon path={mdiAccountCash} size={1} />, label: "Gratuities", visible: inclusionsData.gratuities},
    {icon: <Icon path={mdiAccountGroup} size={1} />, label: "Group Departure", visible: inclusionsData.group_departure},
    {icon: <Icon path={mdiWifi} size={1} />, label: "Wi-Fi", visible: inclusionsData.wifi},
    {icon: <Icon path={mdiHomeCity} size={1} />, label: "Accommodation", visible: inclusionsData.accommodation},
  ];
};

const safeFormatDate = (date: string) => {
  try {
    return format(parse(date, 'dd/MM/yyyy', new Date()), 'dd MMM yyyy');
  } catch {
    return date;
  }
};

const numberValue = (value: unknown): number => {
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  if (typeof value === "string") return parseCurrencyString(value) || 0;
  return Number(value) || 0;
};

interface ShowPageProps {
  isPartner?: boolean;
}

const ShowPage: React.FC<ShowPageProps> = ({ isPartner = false }) => {
  const isMobile = useBreakpoint();
  const navigate = useNavigate();
  const location = useLocation();
  const syncedItinerarySearchRef = useRef<string | null>(null);
  const params = useParams();
  const [searchParams] = useSearchParams();
  const {username} = useAuth();
  const customerUsername = isPartner ? "" : username;

  const seriesApi = useMemo(() => new SeriesApi(), []);
  const agentsApi = useMemo(() => new AgentsApi(), []);
  const listApi = useMemo(() => new ListApi(), []);

  const [loading, setLoading] = useState<boolean>(true);
  const [tourLoading, setTourLoading] = useState<boolean>(false);
  const [itinerary, setItinerary] = useState<Itinerary | null>(null);
  const [selectedTour, setSelectedTour] = useState<Tour | null>(null);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [allAgents, setAllAgents] = useState<Agent[]>([]);
  const [agentsLoading, setAgentsLoading] = useState<boolean>(true);
  const [agents, setAgents] = useState<Agent[]>([]);
  const [agentsStates, setAgentsStates] = useState<string[]>([]);
  const [states, setStates] = useState<string[]>([]);
  const [cities, setCities] = useState<string[]>([]);
  const [citiesForAddress, setCitiesForAddress] = useState<SelectOption[]>([]);
  const [statesForAddress, setStatesForAddress] = useState<SelectOption[]>([]);
  const [countriesForAddress, setCountriesForAddress] = useState<SelectOption[]>([]);
  const [showAgentsResults, setShowAgentsResults] = useState<boolean>(false);
  const [agentData, setAgentData] = useState<Agent | null>(null);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);
  const [showContactAgent, setShowContactAgent] = useState<boolean>(false);
  const [showPricingSummary, setShowPricingSummary] = useState<boolean>(false);
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [tourInclusives, setTourInclusives] = useState<TourInclusions[]>([]);
  const [isInclusionModalOpen, setIsInclusionModalOpen] = useState(false);
  const [selectedInclusion, setSelectedInclusion] = useState<{icon: any, label: string, tooltip: any} | null>(null);
  const [pricingSummary, setPricingSummary] = useState<any | null>(null);
  const [paymentMethod, setPaymentMethod] = useState<string>("");
  const [type, setType] = useState<string>("series");
  const [bookingAddons, setBookingAddons] = useState<BookingAddOns[]>([]);
  const [paymentMethods, setPaymentMethods] = useState<Record<string, any> | null>(null);
  const [showTravelers, setShowTravelers] = useState<boolean>(false);
  const [travelersAnimating, setTravelersAnimating] = useState<boolean>(false);
  const travelersWidgetRef = useRef<HTMLDivElement>(null);
  const [travelerCounts, setTravelerCounts] = useState<Record<string, number>>({});
  const [selectedTravelers, setSelectedTravelers] = useState<string[]>([]);
  const [bookingForm] = Form.useForm();
  const [activeTab, setActiveTab] = useState<string>("description");
  const hasUserSelectedTab = useRef(false);
  const hasAutoSelectedItineraryTab = useRef(false);
  const [showAdminFee, setShowAdminFee] = useState<boolean>(false);
  const [currencyAdminFee, setCurrencyAdminFee] = useState<string>("0");
  const [currencyAddOnsTotal, setCurrencyAddOnsTotal] = useState<string>("0");
  const [currencyGrandTotal, setCurrencyGrandTotal] = useState<string>("0");
  const [currencyNonMalaysiaCharges, setCurrencyNonMalaysiaCharges] = useState<string>("0");
  const [showVisaFee, setShowVisaFee] = useState<boolean>(false);
  const [currencyVisaFee, setCurrencyVisaFee] = useState<string>("0");
  const [promotions, setPromotions] = useState<PromotionSummary[]>([]);
  const [paxItems, setPaxItems] = useState<PaxPriceItem[]>([]);
  const [v3Pax, setV3Pax] = useState<{ tourId: number | null; items: PaxPriceItem[] }>({ tourId: null, items: [] });
  const [promotionDeductions, setPromotionDeductions] = useState<PromotionDeduction[]>([]);
  const [promotionTotal, setPromotionTotal] = useState<number>(0);
  const [promotionCalcLoading, setPromotionCalcLoading] = useState<boolean>(false);
  const promoCalcRequestIdRef = useRef(0);
  const [isFixed, setIsFixed] = useState(false);
  const [activeSection, setActiveSection] = useState<string>("departure-date");
  const [open, setOpen] = useState(false);
  const [cabin, setCabin] = useState<number>(1);
  const [cruiseDeparture, setCruiseDeparture] = useState<CruiseDeparture | undefined>();
  const [cruiseMultiplier, setCruiseMultiplier] = useState<number | undefined>();
  const [cruiseCabinType, setCruiseCabinType] = useState<string | undefined>();
  const [cruiseTourId, setCruiseTourId] = useState<number | undefined>();
  const [cruiseCabins, setCruiseCabins] = useState<CruiseCabinPax[]>([]);
  const [cruiseRoomSelections, setCruiseRoomSelections] = useState<Record<number, CruiseCabin>>({});
  const [cruiseTourDetailLoading, setCruiseTourDetailLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState<PaymentDetails | null>(null);
  const [depositDetailsVisible, setDepositDetailsVisible] = useState<boolean>(false);
  const [currencyDeposit, setCurrencyDeposit] = useState<string>("0");
  const [currencyBalance, setCurrencyBalance] = useState<string>("0");
  const [totalPax, setTotalPax] = useState<number>(0);
  const [showV3InclusionsDrawer, setShowV3InclusionsDrawer] = useState(false);
  const [showV3ReadMore, setShowV3ReadMore] = useState(false);
  const [v3TitleClamped, setV3TitleClamped] = useState(false);
  const v3TitleRef = useRef<HTMLHeadingElement>(null);
  const [showV3BookingFlow, setShowV3BookingFlow] = useState(false);
  const [showHighlightDrawer, setShowHighlightDrawer] = useState(false);
  const [showPriceChart, setShowPriceChart] = useState(false);
  const [showV3TooltipDrawer, setShowV3TooltipDrawer] = useState(false);
  const [v3TooltipItem, setV3TooltipItem] = useState<{label: string, tooltip: any} | null>(null);

  const layoutVersion = getActiveVersion(itinerary ?? undefined, isMobile);

  const hasCabinNavigation = !!itinerary?.cabinNavigation;

  const cruiseCabinGroups = useMemo(
    () => (hasCabinNavigation ? toCabinGroups(cruiseCabins) : undefined),
    [hasCabinNavigation, cruiseCabins]
  );

  const selectCruiseDeparture = (date: string) => {
    const departure = itinerary?.cabinNavigation?.departures.find((d) => d.departure_date === date);
    if (!departure) return;
    setCruiseDeparture(departure);
    autoSelectFirstAvailableCabin(departure);
  };

  const selectCruiseRoomType = (roomType: CruiseRoomType) => {
    setCruiseMultiplier(roomType.multiplier);
    setCruiseCabins([newCabin(roomType.multiplier)]);

    const remembered = cruiseRoomSelections[roomType.multiplier];
    const isRememberedStillValid = remembered && roomType.cabins.some((c) => c.tour_id === remembered.tour_id && c.available);
    const cabin = isRememberedStillValid ? remembered : roomType.cabins.find((c) => c.available);

    if (cabin) {
      selectCruiseCabin(cabin, roomType.multiplier);
    } else {
      setCruiseCabinType(undefined);
      setCruiseTourId(undefined);
    }
  };

  const applySelectedTour = (selected: any, itineraryData: any) => {
    const summary = {
      priceCurrency: itineraryData.priceCurrency,
      tourName: itineraryData.caption,
      tourCode: selected.code,
      country: selected.departure_location,
      departureDate: `${selected.departure_date} - ${selected.arrival_date}`,
      fareBreakdown: {
        promo: "",
        items: [],
        total: 0
      },
      currencyAddOnsTotal: "0",
    };

    setCurrencyGrandTotal(currencyDisplay(itineraryData.priceCurrency, "0"));
    setCurrencyNonMalaysiaCharges(currencyDisplay(itineraryData.priceCurrency, "0"));
    setPricingSummary(summary);

    if (selected.allow_customer_pay_deposit) {
      setCurrencyDeposit(currencyDisplay(itineraryData.priceCurrency, numberValue(selected.b2c2b_customer_deposit)));
    }
  };

  const selectCruiseCabin = async (cruiseCabin: CruiseCabin, multiplier?: number, itineraryOverride?: any) => {
    const roomMultiplier = multiplier ?? cruiseMultiplier;
    if (roomMultiplier !== undefined) {
      setCruiseRoomSelections((prev) => ({ ...prev, [roomMultiplier]: cruiseCabin }));
    }

    setCruiseCabinType(cruiseCabin.cabin_type);
    setCruiseTourId(cruiseCabin.tour_id);

    setCruiseTourDetailLoading(true);
    try {
      const targetItinerary = itineraryOverride ?? itinerary;
      const cabinNavigation = await seriesApi.getCabinNavigation(targetItinerary?.id, "b2c2b", cruiseCabin.tour_id);
      const detail = findCabinDetail(cabinNavigation, cruiseCabin.tour_id);
      if (!detail) throw new Error("Cabin detail not found in response");
      const selected = { ...detail } as Tour;
      setSelectedTour(selected);
      setSelectedDate(selected.departure_date);
      if (targetItinerary) applySelectedTour(selected, targetItinerary);
    } catch (error) {
      console.error(error);
      notification.error({ message: "An error occurred while loading the selected cabin's price." });
    } finally {
      setCruiseTourDetailLoading(false);
    }
  };

  // Multiplier-1 (Single Room) sorts first if left in ascending order, which
  // would make it the default auto-selected cabin any time it shares a
  // departure with real multi-pax cabins - and since selecting it hides the
  // room-type selector, the customer would have no way back to those cabins.
  // Try real cabins first; only fall back to Single Room when it's the only
  // option for this departure.
  const prioritizeRoomTypes = (roomTypes: CruiseRoomType[]) =>
    [...roomTypes].sort((a, b) => {
      if (a.multiplier === 1 && b.multiplier !== 1) return 1;
      if (b.multiplier === 1 && a.multiplier !== 1) return -1;
      return a.multiplier - b.multiplier;
    });

  const autoSelectFirstAvailableCabin = (departure: CruiseDeparture) => {
    setCruiseMultiplier(undefined);
    setCruiseCabinType(undefined);
    setCruiseTourId(undefined);
    setCruiseCabins([]);
    setCruiseRoomSelections({});

    for (const roomType of prioritizeRoomTypes(departure.room_types || [])) {
      const firstAvailableCabin = roomType.cabins.find((c) => c.available);
      if (firstAvailableCabin) {
        setCruiseMultiplier(roomType.multiplier);
        setCruiseCabins([newCabin(roomType.multiplier)]);
        selectCruiseCabin(firstAvailableCabin, roomType.multiplier);
        return;
      }
    }
  };

  const findCabinInDeparture = (departure: CruiseDeparture, tourId?: number) => {
    if (tourId != null) {
      for (const roomType of departure.room_types || []) {
        const cabin = roomType.cabins.find((c) => c.tour_id === tourId);
        if (cabin) return { cabin, multiplier: roomType.multiplier };
      }
    }
    for (const roomType of prioritizeRoomTypes(departure.room_types || [])) {
      const cabin = roomType.cabins.find((c) => c.available);
      if (cabin) return { cabin, multiplier: roomType.multiplier };
    }
    return null;
  };

  useEffect(() => {
    if (!hasCabinNavigation) return;
    const travelers = flattenCabinsToTravelers(cruiseCabins);
    setSelectedTravelers(travelers);
    setTravelerCounts(travelerCountsFrom(travelers));
  }, [hasCabinNavigation, cruiseCabins]);

  // Lock background scroll while any V3 drawer / popup is open (iOS-safe scroll-bleed fix).
  useScrollLock(
    showV3InclusionsDrawer ||
    showV3TooltipDrawer ||
    showHighlightDrawer ||
    showPriceChart ||
    showV3BookingFlow ||
    isModalOpen ||
    isInclusionModalOpen
  );

  const handleShareLink = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.delete("ref");
    url.searchParams.delete("keyword");

    if (!navigator.clipboard) {
      notification.error({ message: "Unable to copy link. Please copy the URL from your browser." });
      return;
    }

    navigator.clipboard.writeText(url.toString()).then(() => {
      message.success("Itinerary link is ready to be shared to your friends and family");
    }).catch(() => {
      notification.error({ message: "Unable to copy link. Please copy the URL from your browser." });
    });
  }, []);
  const [bookingInputParams, setBookingInputParams] = useState<BookingInput>();
  const passengers = Form.useWatch("passengers", bookingForm) || [];
  const nonMalaysiaPassengerCount = useMemo(() => {
    return passengers.filter((passenger: { nationality?: string }) => {
      const nationality = (passenger?.nationality || "").toString().trim().toLowerCase();
      return !!nationality && nationality !== "malaysia";
    }).length;
  }, [passengers]);
  const nonMalaysiaChargeAmount = useMemo(() => {
    return Number(selectedTour?.non_malaysian_charge || 0) * nonMalaysiaPassengerCount;
  }, [selectedTour, nonMalaysiaPassengerCount]);

  const resetAgents = useCallback((sourceAgents?: Agent[]) => {
    const base = sourceAgents ?? allAgents;
    const states = uniqBy(base, "state");
    const cities = uniqBy(base, "city");
    setStates(states);
    setCities(cities);
  }, [allAgents]);

  const initialPassengers = Array.from(
    { length: selectedTravelers.length || 1 },
    (_, i) => ({
      ...defaultPassengerInfos(!customerUsername && i === 0),
    })
  );

  const getItinerary = useCallback(async (date?: string | null, requestedType?: string | null, selectedTourCode?: string | null, selectedTourId?: number | null) => {
    setTourLoading(true);

    if (requestedType) setType(requestedType);
    try {
      const itineraryData: Itinerary | any = await seriesApi.getItineraryV2(params.id, requestedType || undefined, date || undefined, "b2c2b", searchParams.get("ref"), selectedTourId ?? undefined);

      // Cruise mode is decided by the API's next_api flag (same rule as B2B),
      // not the ?type= URL param — a shared/direct link without ?type=cruise
      // must still land on the cabin-navigation UI for a world cruise.
      if (itineraryData.cruiseCabinDisplay && itineraryData.nextApi === "cruise") {
        const cabinNavigation = await seriesApi.getCabinNavigation(params.id, "b2c2b");
        if (cabinNavigation) itineraryData.cabinNavigation = cabinNavigation;
        if (cabinNavigation) setType("cruise");
      }
      setItinerary(itineraryData);

      if (itineraryData.tours && itineraryData.tours.length > 0) {
        let selected: any = itineraryData.tours[0];
        
        if (selectedTourId != null) {
          const byId = itineraryData.tours.find((tour: any) => tour.id === selectedTourId);
          if (byId) selected = byId;
        } else if (date) {
          const byDate = itineraryData.tours.find(({departure_date, code}) => departure_date === date && (!selectedTourCode || code === selectedTourCode));
          if (byDate) selected = byDate;
        }

        setTourInclusives(inclusions(itineraryData.includings, selected, itineraryData, itineraryData.v2 || itineraryData.v3, isMobile, itineraryData.v3 && isMobile));
        setBookingAddons([]);

        if (!itineraryData.cabinNavigation) {
          applySelectedTour(selected, itineraryData);

          const resolvedDate = selected?.departure_date || date || "";
          const currentDepartDate = searchParams.get("depart_date");

          if (resolvedDate && resolvedDate !== currentDepartDate) {
            const nextParams = new URLSearchParams(searchParams);
            if (requestedType) nextParams.set("type", requestedType);
            nextParams.set("depart_date", resolvedDate);
            const nextSearch = `?${nextParams.toString()}`;
            syncedItinerarySearchRef.current = nextSearch;
            navigate(
              { pathname: location.pathname, search: nextSearch },
              { replace: true }
            );
          }

          setSelectedTour(selected);
          setSelectedDate(resolvedDate);

          const seededPaxMultiplier = selected.booking_pax_multiplier || 1;
          const initialCounts = Object.keys(selected.room_types || pricingCategory(requestedType || "")).reduce(
            (acc, category) => {
              acc[category] = category === "adult" ? seededPaxMultiplier : 0;
              return acc;
            },
            {} as Record<string, number>
          );

          setSelectedTravelers(Array(seededPaxMultiplier).fill("adult"));
          setTravelerCounts(initialCounts);
          setPaxItems([]);
          setBookingInputParams({ ...initialCounts, allowTripleRoom: selected.allow_triple_room } as BookingInput);
          setCabin(1);

          //resets form
          if(itineraryData.b2c2b){
            bookingForm.resetFields();
            bookingForm.setFieldsValue({passengers: initialPassengers});
          }
        } else {
          const departures = itineraryData.cabinNavigation.departures || [];
          const targetDate = selected?.departure_date || date;
          const departure = departures.find((d: any) => d.departure_date === targetDate) || departures[0];

          if (departure) {
            setCruiseDeparture(departure);
            setSelectedDate(departure.departure_date);

            const match = findCabinInDeparture(departure, selected?.id);
            if (match) {
              setCruiseMultiplier(match.multiplier);
              setCruiseCabins([newCabin(match.multiplier)]);
              setCruiseRoomSelections({});
              await selectCruiseCabin(match.cabin, match.multiplier, itineraryData);
            }
          }
        }
      }
    } catch(error) {
      console.error(error)
      notification.error({ message: "An error occured while loading itinerary." });
    } finally {
      setLoading(false);
      setTourLoading(false);
    }
  }, [params.id, seriesApi, searchParams, navigate, location.pathname]);

  useEffect(() => {
    if (hasAutoSelectedItineraryTab.current || hasUserSelectedTab.current) return;
    if (itinerary?.itinerary_plans && itinerary.itinerary_plans.length > 0) {
      setActiveTab("itinerary");
      hasAutoSelectedItineraryTab.current = true;
    }
  }, [itinerary?.itinerary_plans]);

  useEffect(() => {
    if (syncedItinerarySearchRef.current === location.search) {
      syncedItinerarySearchRef.current = null;
      return;
    }

    const departDate = searchParams.get("depart_date");
    const requestedType = searchParams.get("type");

    const fetchData = () => {
      B2C2BApi.getAllPaymentMethods()
        .then((paymentMethods)=>{
          getItinerary(departDate, requestedType);
          setPaymentMethods(paymentMethods);
        })
        .catch(() => {
          notification.error({ message: "An error occurred while loading payment methods." });
          setLoading(false);
        });
    };

    fetchData();
  }, [location.search, searchParams, getItinerary]);

  useEffect(() => {
    if (itinerary != null) {
      const storedCities = customCookies.get("cities");
      setAgentsLoading(true);

      if (!itinerary.b2c2b) {
        agentsApi.getAgents({ departments: ["Series", "Flight", "Visa"] })
          .then((agentsData: Agent[]) => {
            const states = uniqBy(agentsData, "state"), cities = uniqBy(agentsData, "city");
            setAgents(agentsData);
            setAllAgents(agentsData);
            setStates(states);
            setCities(cities);
            resetAgents(agentsData);
          })
          .catch(() => {
            notification.error({ message: "An error occured while loading agents." });
          })
          .finally(() => { setLoading(false); setAgentsLoading(false); });
      } else{
        Promise.all([
          B2C2BApi.getAgents(itinerary.id),
          listApi.getCountries(),
          storedCities === undefined ? listApi.getCities() : storedArray$(storedCities),
        ])
          .then(([agentsData, countries, cities]) => {
            //Agent Selection
            const agentStates = uniqBy(agentsData, "state");
            setAgents(agentsData);
            setAgentsStates(agentStates);

            //for Address tab
            const statesByCities = listApi.getStatesOptionsByCities(cities);
            setCountriesForAddress(countries);
            setCitiesForAddress(cities);
            setStatesForAddress(statesByCities);

            //for Contact Agents Form
            const statesFilter = uniqBy(agentsData, "state"), citiesFilter = uniqBy(agentsData, "city");
            setAllAgents(agentsData);
            setCities(citiesFilter);
            setStates(statesFilter);
          })
          .catch(() => {
            notification.error({ message: "An error occured while loading agents." });
          })
          .finally(() => { setLoading(false); setAgentsLoading(false); });
      }
    }
  }, [agentsApi, itinerary?.id]);

  const showModal = (agent: Agent) => {
    setIsModalOpen(true);
    setAgentData(agent);
  };

  const closeModal = () => setIsModalOpen(false);

  const filterCities = useCallback((searchStr?: string) => {
    if (searchStr == undefined) {
      resetAgents();
      return;
    }
    const filtered: Agent[] = allAgents.filter(a => a.state == searchStr);
    const results = uniqBy(filtered, "city");
    setCities(results);
  }, [allAgents, resetAgents]);

  const filterStates = useCallback((searchStr?: string) => {
    if (searchStr == undefined) {
      resetAgents();
      return;
    }
    const filtered: Agent[] = allAgents.filter(a => a.city == searchStr);
    const results = uniqBy(filtered, "state");
    setStates(results);
  }, [allAgents, resetAgents]);

  const findAgents = useCallback((formValues: any) => {
    const filtered = allAgents.filter(a =>
      (formValues.state == undefined || a.state === formValues.state) &&
      (formValues.city == undefined || a.city === formValues.city)
    );
    setAgents(filtered);
    setShowAgentsResults(true);
  }, [allAgents]);

  const toggleDescription = () => setIsCollapsed(prev => !prev);
  const toggleContactAgent = () => { setShowContactAgent(prev => !prev); setShowTravelers(false); };
  const togglePricingSummary = () => setShowPricingSummary(prev => !prev);
  const toggleTravelers = () => { setShowTravelers(prev => !prev); setShowContactAgent(false); };
  const highlightTravelers = () => {
    if (travelersWidgetRef.current) travelersWidgetRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTravelersAnimating(true);
  };

  const updatePriceSummary = useCallback((event: any) => {
    if (!pricingSummary) return;
    const fareItems = Object.values(summarizeFare(event.items, type));
    const _totalPax = event.items.length;
    const bookingAddons = addons(selectedTour, _totalPax);
    let total = totalPrice(event.items) || 0;

    const categories = Object.keys(pricingCategory(selectedTour?.room_types || type));
    const sortedFareItems = fareItems.sort((a: any, b: any) => {
      const orderA = categories.indexOf(a.id);
      const orderB = categories.indexOf(b.id);
      return orderA - orderB;
    });

    const newFareBreakdown = {
      ...pricingSummary.fareBreakdown,
      promo: (priceTypes[event.promo] || "").replace(/\d/g, "").trim(),
      items: sortedFareItems,
      total
    };

    const addOnsTotal = bookingAddons.reduce((sum, addon) => sum + addon.value, 0);
    total = total + addOnsTotal;

    const currencyAddOnsTotal = currencyDisplay(pricingSummary.priceCurrency, addOnsTotal.toFixed(2));
    const currencyGrandTotal = currencyDisplay(pricingSummary.priceCurrency, total.toFixed(2));

    setPricingSummary(ps => (ps ? { ...ps, fareBreakdown: newFareBreakdown } : ps));
    setCurrencyAddOnsTotal(currencyAddOnsTotal);
    setCurrencyGrandTotal(currencyGrandTotal);
    setBookingAddons(bookingAddons);
    setTotalPax(_totalPax);
    setPaxItems(event.items || []);

  }, [pricingSummary, selectedTour, type]);

  useEffect(() => {
    const currency = pricingSummary?.priceCurrency || "MYR";
    const showAdminFee = CARDS.includes(paymentMethod);
    let total = Number(pricingSummary?.fareBreakdown?.total) || 0, currencyAdminFee = "0";

    const addOnsTotal = bookingAddons.reduce((sum, addon) => sum + addon.value, 0);
    total = total + addOnsTotal;

    const nonMalaysiaCharge = nonMalaysiaChargeAmount;
    total += nonMalaysiaCharge;

    // Visa-fee deduction: the backend selling_price subtracts a per-pax visa_fee,
    // so mirror it here (before admin fee) to keep the total equal to what's charged.
    const visaDeduction = Number(selectedTour?.visa_fee || 0) * selectedTravelers.length;
    total -= visaDeduction;

    // Promotion deduction comes from the backend calculator (never computed
    // locally); subtracted before the admin fee since the card fee is charged
    // on the post-promotion payable.
    total -= promotionTotal;
    total = Math.max(0, total);

    const ccRate = itinerary?.ccRate;
    if (ccRate !== undefined) {
      if (showAdminFee && ccRate > 0) {
        const adminFee = Number(total * ccRate);
        currencyAdminFee = currencyDisplay(currency, adminFee.toFixed(2));
        total += adminFee;
      }
    }

    const currencyAddOnsTotal = currencyDisplay(currency, addOnsTotal.toFixed(2));
    const currencyGrandTotal = currencyDisplay(currency, total.toFixed(2));
    setShowAdminFee(showAdminFee);
    setCurrencyAdminFee(currencyAdminFee);
    setCurrencyAddOnsTotal(currencyAddOnsTotal);
    setCurrencyGrandTotal(currencyGrandTotal);
    setCurrencyNonMalaysiaCharges(currencyDisplay(currency, nonMalaysiaCharge.toFixed(2)));
    setShowVisaFee(visaDeduction > 0);
    setCurrencyVisaFee(currencyDisplay(currency, visaDeduction.toFixed(2)));

  }, [itinerary, selectedTravelers, paymentMethod, pricingSummary, bookingAddons, nonMalaysiaChargeAmount, selectedTour, promotionTotal]);

  // Key the promotion effects on the tour identity value itself: re-selecting
  // the same departure date rebuilds itinerary/tour objects (getItinerary) but
  // must not clear or refetch promotion state — only a real tour change may.
  const promotionsTourId = itinerary?.b2c2b ? Number(selectedTour?.id) || null : null;

  useEffect(() => {
    // Clear immediately so a previous tour's promotions never linger.
    setPromotions([]);
    setPromotionDeductions([]);
    setPromotionTotal(0);
    if (!promotionsTourId) return;

    let stale = false;
    B2C2BApi.getPromotions(promotionsTourId)
      .then(list => { if (!stale) setPromotions(list); })
      .catch(() => { if (!stale) setPromotions([]); });
    return () => { stale = true; };
  }, [promotionsTourId]);

  // Single owner of the calculate call for both flows: the v2 booking form
  // feeds paxItems via updatePriceSummary, the v3 form reports its own items
  // via onPaxItemsChange. The response persists here across form open/close.
  // v3 items are tagged with their tour id: during a tour switch the form's
  // report effect lags one render behind, so items from another tour must be
  // treated as empty rather than calculated against the new tour.
  const activePaxItems = layoutVersion === "v3"
    ? (v3Pax.tourId === promotionsTourId ? v3Pax.items : [])
    : paxItems;
  const promotionPax = useMemo(
    () => (selectedTour ? buildPromotionPax(activePaxItems, selectedTour) : []),
    [activePaxItems, selectedTour]
  );
  const promotionPaxKey = JSON.stringify(promotionPax);

  useEffect(() => {
    // Bumping the token here invalidates any in-flight response as soon as the
    // inputs change; only the latest request may write state (last-wins).
    const requestId = ++promoCalcRequestIdRef.current;

    if (!promotionsTourId || promotions.length === 0 || promotionPax.length === 0) {
      setPromotionDeductions([]);
      setPromotionTotal(0);
      setPromotionCalcLoading(false);
      return;
    }

    setPromotionCalcLoading(true);
    B2C2BApi.calculatePromotions({
      tour_id: promotionsTourId,
      pax: promotionPax,
      price_type: "",
      currency: pricingSummary?.priceCurrency || itinerary?.priceCurrency || "MYR",
    })
    .then(response => {
      if (requestId !== promoCalcRequestIdRef.current) return;
      const { deductions, total } = parsePromotionCalculation(response);
      setPromotionDeductions(deductions);
      setPromotionTotal(total);
      setPromotionCalcLoading(false);
    })
    .catch(() => {
      if (requestId !== promoCalcRequestIdRef.current) return;
      setPromotionDeductions([]);
      setPromotionTotal(0);
      setPromotionCalcLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itinerary?.b2c2b, selectedTour?.id, promotions, promotionPaxKey]);

  const promotionDeductionRows = useMemo(() => {
    const currency = pricingSummary?.priceCurrency || "MYR";
    return promotionDeductions.map(promotion => ({
      title: promotion.title,
      entitledPaxCount: promotion.entitledPaxCount,
      currencyAmount: currencyDisplay(currency, promotion.amount.toFixed(2)),
    }));
  }, [promotionDeductions, pricingSummary?.priceCurrency]);

  useEffect(() => {
    if (selectedTour) {
      const updatedBookingInput = {
        ...travelerCounts,
        allowTripleRoom: selectedTour.allow_triple_room
      } as BookingInput;

      setBookingInputParams(updatedBookingInput);
    }

  }, [selectedTour, travelerCounts]);

  useEffect(() => {
    
    if(selectedTour && selectedTour.allow_customer_pay_deposit){
      const priceCurrency = pricingSummary?.priceCurrency || "MYR",
            publicBanks = ['public_bank', 'public_bank_2'],
            showAdminFee = publicBanks.includes(paymentMethod) || CARDS.includes(paymentMethod),
            ccRate = numberValue(itinerary?.ccRate),
            customerDeposit = numberValue(selectedTour?.b2c2b_customer_deposit);
      
      let _currencyAdminFee = currencyDisplay(priceCurrency, 0),
          grandTotal = parseCurrencyString(currencyGrandTotal),
          totalDeposit = customerDeposit * totalPax,
          currentBalance = depositDetailsVisible ? totalDeposit : grandTotal;
          
      if (ccRate !== undefined) {
        if (showAdminFee && ccRate > 0) {
          const serviceFee = Number(currentBalance * ccRate);
          _currencyAdminFee = currencyDisplay(priceCurrency, serviceFee.toFixed(2));
          
          if(depositDetailsVisible){
            totalDeposit += serviceFee;
          }
        }
      }

      const currencyDeposit = currencyDisplay(pricingSummary.priceCurrency, totalDeposit.toFixed(2));
      const currencyBalance = currencyDisplay(priceCurrency, (grandTotal - totalDeposit).toFixed(2));
      
      const paymentDetails: PaymentDetails = {
        final_deposit: currencyDeposit,
        final_total: currencyGrandTotal,
        balance: currencyBalance,
        final_payment_date: dayjs(selectedTour?.final_payment_date, "DD/MM/YYYY").format("DD MMM YYYY")
      };
      
      setPaymentDetails(paymentDetails);
      setCurrencyDeposit(currencyDeposit);
      setCurrencyBalance(currencyBalance);
      setCurrencyAdminFee(_currencyAdminFee);

    } else {
      setPaymentDetails(null);
    }
  }, [itinerary, selectedTour, currencyGrandTotal, paymentMethod, pricingSummary, totalPax, depositDetailsVisible]);

  const updateFareType = (fareType: string) => {
    setDepositDetailsVisible(prev => {
      return fareType === PAYMENT_TERMS.DEPOSIT;
    });
  }

  const BookingForm = () => {
    return itinerary &&
      <BookingSelection
        bookingForm={bookingForm}
        tourId={hasCabinNavigation ? (cruiseTourId ?? selectedTour?.id) : selectedTour?.id}
        priceCurrency={itinerary.priceCurrency}
        prices={selectedTour?.prices}
        maxSeats={itinerary.maxBookingSeats}
        departureDate={selectedTour?.departure_date}
        paxMultiplier={hasCabinNavigation ? (cruiseMultiplier || 1) : (selectedTour?.booking_pax_multiplier || 1)}
        category={itinerary.category}
        paymentMethods={paymentMethods}
        updatePrice={(event)=>updatePriceSummary(event)}
        updatePaymentMethod={(event)=>setPaymentMethod(event)}
        checkoutEnabled={itinerary.checkoutEnabled}
        checkoutDisabledMessage={itinerary.checkoutDisabledMessage}
        agentChangeReasons={itinerary.agentChangeReasons}
        travelers={selectedTravelers}
        bookingInputParams={bookingInputParams}
        cabin={hasCabinNavigation ? cruiseCabins.length : cabin}
        cabinGroups={cruiseCabinGroups}
        isCruise={hasCabinNavigation}
        agentsData={agents}
        agentStates={agentsStates}
        cities={citiesForAddress}
        states={statesForAddress}
        countries={countriesForAddress}
        v2={itinerary.v2}
        paymentDetails={paymentDetails}
        updateFareType={updateFareType}
        onSelectTraveler={isMobile ? () => setShowTravelers(true) : highlightTravelers}
        isPartner={isPartner}
        hasInfantB2c={selectedTour?.has_infant_b2c}
        childAgeRanges={itinerary.child_age_ranges}
      />
  }

  const OriginalLayout = () => {
    const dates = (itinerary?.tours?.length || 0) === 0
    ? []
    : itinerary?.tours?.map((tour: any) => {
        const almostGuaranteed = tour.guaranteed_indicator?.includes("to G") ?? false;
        const type = tour.guaranteed_indicator == "G" ? "guaranteed" : almostGuaranteed ? "almost-guaranteed" : "";
        const indicator = almostGuaranteed ? `${tour.guaranteed_indicator}o` : "";
        return {
          id: tour.id,
          code: tour.code,
          date: tour.departure_date,
          price: tour.price, type,
          location: tour.departure_location,
          indicator
        };
      });

    return (
      <Layout style={layoutStyle}>
        <>
          <Headline showSearch={false} bannerImage={itinerary?.coverImage || ""} breadcrumbs={breadcrumbs}>
            <div id="show-page_header"> 
              <Flex gap={10}>
                <h1>Itinerary</h1> 
                <div className="tour_details"> 
                  <span className="tour_details_code"> <Icon path={mdiFileDownload} size="16px" />  {selectedTour?.code} </span> 
                  <span className="tour_details_category"> Category:  {itinerary?.category} </span> 
                </div>
              </Flex>
            </div>
          </Headline>

          <div id="show-page_subheader">
            <div className="caption-title-with-badge">
              <h1>{selectedTour?.caption}</h1>
              {
                itinerary?.isNew && <span className="caption-new-badge">New</span>
              }
            </div>
            <TourDateSelector 
              dates={dates ?? []} 
              selectedDate={selectedDate} 
              selectedTourCode={selectedTour?.code} 
              selectTour={({date, code, id}) => getItinerary(date, type, code, id)}
              category={itinerary?.category || ""}
              isNew={!!itinerary?.isNew}/>
          </div>
        </>

        {
          !loading && (
            <Layout id="show-page_body">
              {
                tourLoading ? (
                  <Space direction="vertical" style={{width: '100%'}}>
                    <Skeleton/>
                    <Skeleton/>
                    <Skeleton/>
                  </Space>
                ) : (
                  <>
                    <Content>
                      <div className="details">
                        <Flex gap={10} vertical>
                          {
                            (tourInclusives.some(x => x.visible) || selectedTour?.guaranteed_departure) && (
                              <div className="details-container">
                                <div className="details-container_header"> Tour Inclusive </div>
                                <div className="details-container_content"> 
                                  <div id="things-to-know">
                                    {
                                      tourInclusives.filter(item => item.visible)
                                        .map((item, index) => (
                                          <div key={index} className="item">
                                            <div className="icon"> {item.icon} </div>
                                            <label>{item.label}</label>
                                            {item.content && <div className="item-description">{item.content()}</div>}
                                          </div>
                                        ))
                                    }

                                    {itinerary && <ItineraryDownloadLinks itinerary={itinerary} />}

                                    {
                                      selectedTour?.guaranteed_indicator == "G" && (
                                        <div className="item guaranteed">
                                          <div className="icon"> <Icon path={mdiShieldAirplane} size={1} /></div>
                                          <label>Guaranteed Departure</label>
                                        </div>
                                      )
                                    }
                                  </div>
                                </div>
                              </div>
                            )
                          }

                          <DetailsSection header="Highlights" show={!!selectedTour?.highlight_customer}>
                            <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                              {selectedTour?.highlight_customer}
                            </Markdown>
                          </DetailsSection>

                          <DetailsSection header="Important Section" show={!!selectedTour?.important_notice}>
                            <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                              {selectedTour?.important_notice}
                            </Markdown>

                          </DetailsSection>

                          <div className="details-container">
                            <div className="details-container_header"> Description </div>
                            <div className="details-container_content"> 
                              <div id="description" className={`${isCollapsed && "collapsed"}`}>
                                <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{itinerary?.description}</Markdown>
                              </div>
                              <Button className="toggle-description" color="default" variant="filled" block onClick={toggleDescription}>{ isCollapsed ? "Expand" : "Collapse"} 
                                <Icon path={isCollapsed ? mdiMenuDown : mdiMenuUp} size="19px" /> 
                              </Button>
                            </div>
                          </div>

                          {
                            (selectedTour?.flights?.length ?? 0) > 0  && (
                              <div className="details-container">
                                <div className="details-container_header"> Schedule Flight(s) </div>
                                <div className="details-container_content"> 
                                  <Flex gap={20} vertical>
                                    {
                                      selectedTour?.flights.map((flight:any) => (
                                        <div className="schedule" key={flight.id}>
                                          <div className="flight-destination">
                                            <Icon path={mdiAirplane} size="17px" />
                                            <label> {flight.from_airport} &gt; {flight.to_airport} </label>
                                          </div>
                                          <div className="flight-details">
                                            <div className="flight-details_airline">
                                              <img src={flight.airline_logo} />
                                              <span>{flight.airline}</span>
                                              <span className="flight-details_flight-no">{flight.flight_no}</span>
                                            </div>
                                            <div className="flight-details_datetime">
                                              <div className="from">
                                                <span className="flight-details_date">{flight.departure_date}, </span>
                                                <span className="flight-details_time">{flight.departure_time}</span>
                                                <span className="flight-details_location">{flight.from_airport}</span>
                                              </div>
                                              <div className="flight-details_datetime_icon">
                                                <img src="/iceholidays-assets/images/plane.png" />
                                              </div>
                                              <div className="to">
                                                <span className="flight-details_date">{flight.arrival_date}, </span>
                                                <span className="flight-details_time">{flight.arrival_time}</span>
                                                <span className="flight-details_location">{flight.to_airport}</span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    }
                                  </Flex>
                                </div>
                              </div>
                            )
                          }
                          {
                            selectedTour && selectedTour.prices && selectedTour.prices.length > 0 && (
                              !itinerary?.b2c2b ? <PriceDetails 
                                                    priceCurrency={itinerary?.priceCurrency || "MYR"} 
                                                    prices={selectedTour?.prices}
                                                    roomTypes={selectedTour?.room_types}/>
                                                :  BookingForm()
                            )
                          }

                        </Flex>
                      </div>
                    </Content>
                    {
                      itinerary?.b2c2b ? (
                        <Sider id="pricing-summary" width="280px" style={siderStyle} className={`contact-agent-sider ${showPricingSummary && "show-contact-agent-mobile"}`}>
                          <div className="toggle-contact-agent" onClick={togglePricingSummary}>
                            <span>Summary</span>
                          </div>

                          <div className="contact-agent">
                            <Affix offsetTop={50}>
                              <Button className="collapse-contact-agent" color="default" variant="text" 
                                icon={<Icon path={mdiClose} size="19px" />}
                                onClick={togglePricingSummary}/>
                              <PricingSummary 
                                header="Summary" 
                                ccRate={itinerary.ccRate} 
                                summary={pricingSummary} 
                                addOns={bookingAddons}
                                paymentMethod={paymentMethod}
                                showNonMalaysiaCharge={nonMalaysiaChargeAmount > 0}
                                currencyNonMalaysiaCharges={currencyNonMalaysiaCharges}
                                nonMalaysiaCharge={nonMalaysiaChargeAmount}/>
                            </Affix>
                          </div>
                        </Sider>
                      ) : (
                        <Sider width="265px" style={siderStyle} className={`contact-agent-sider ${showContactAgent && "show-contact-agent-mobile"}`}>
                          <div className="toggle-contact-agent" onClick={toggleContactAgent}> 
                            <span>Contact Agent</span>
                          </div>
                          <div className="contact-agent">
                            <div className="contact-agent_header"> 
                              <span>Contact Agent</span>
                              <Button className="collapse-contact-agent" color="default" variant="text" 
                                icon={<Icon path={mdiClose} size="19px" />}
                                onClick={toggleContactAgent}/>
                            </div>
                            <div className="contact-agent_content"> 
                              <ContactAgentsForm 
                                states={states} 
                                cities={cities} 
                                findAgents={findAgents} 
                                filterCities={filterCities}
                                filterStates={filterStates}/>

                              {
                                showAgentsResults && (
                                  <div className="search-results">
                                    <Flex vertical gap={20}>
                                      {
                                        agents.length > 0 && agents.map((agent:Agent) => {
                                          return (
                                            <Row key={agent.id} gutter={2} justify="space-between" className="agent-info">
                                              <Col flex="180px"><span className="company" onClick={()=>showModal(agent)}>
                                                {agent.name}</span>
                                              </Col>
                                              <Col flex="none"><Button href={whatsappLink(agent.whatsapp!)} target="_blank" color="default" variant="filled" shape="circle" size="small" icon={<Icon path={mdiPhoneInTalkOutline} size="16px" />}/></Col>
                                              <Col flex="none"><Button href={emailLink(agent.email)} target="_blank" color="default" variant="filled" shape="circle" size="small" icon={<Icon path={mdiEmailOutline} size="16px" />}/></Col>
                                              <Col>
                                                <div className="contact-numbers">
                                                  <Button size="small" color="primary" variant="outlined">
                                                    <Icon path={mdiWhatsapp} size="12px" />
                                                    {agent.whatsapp}
                                                  </Button>
                                                </div>
                                              </Col>
                                            </Row>
                                          );
                                        })
                                      }
                                    </Flex>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        </Sider>
                      )
                    }
                  </>
                )
              }
            </Layout>
          )
        }
        
      </Layout>
    );
  }

  useEffect(() => {
    const handleScroll = () => {
      if (isMobile && window.scrollY > 400) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile || !itinerary) return;
    const ids = ["departure-date", "itinerary-section", "booking-notice"];
    const observers = ids.map(id => {
      const el = document.getElementById(id);
      if (!el) return null;
      const obs = new IntersectionObserver(
        ([entry]) => { if (entry.isIntersecting) setActiveSection(id); },
        { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
      );
      obs.observe(el);
      return obs;
    });
    return () => observers.forEach(obs => obs?.disconnect());
  }, [isMobile, itinerary]);

  useEffect(() => {
    if (layoutVersion !== "v3") return;
    const viewport = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
    if (!viewport) return;
    const original = viewport.getAttribute('content');
    viewport.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no');
    return () => { if (original) viewport.setAttribute('content', original); };
  }, [layoutVersion]);

  useEffect(() => {
    const passengers = bookingForm?.getFieldValue("passengers") || [];
    if(itinerary?.b2c2b && passengers.length > 0){
      passengers[0]["member"] = !customerUsername;
      bookingForm.setFieldsValue({["passengers"]: [...passengers]});
    }
  }, [selectedTravelers, itinerary])

  const V2Layout = () => {
    const maxBookingSeats = selectedTour?.max_booking_seats || 1;
    const bookingPaxMultiplier = selectedTour?.booking_pax_multiplier || 1;
    const paxMultiplier = hasCabinNavigation ? 1 : bookingPaxMultiplier;
    const depositDueDate = dayjs(selectedTour?.final_payment_date, "DD/MM/YYYY").format("DD MMM YYYY");
    const maxCruiseCabins = maxCabinsFor(maxBookingSeats, cruiseMultiplier);

    const dates = hasCabinNavigation
      ? (itinerary?.cabinNavigation?.departures || []).map((departure) => ({
          id: undefined,
          code: departure.departure_date,
          date: departure.departure_date,
          price: currencyDisplay(itinerary?.priceCurrency || "MYR", departure.from_price),
          type: departure.guaranteed ? "guaranteed" : "",
          location: "",
          indicator: ""
        }))
      : (itinerary?.tours?.length || 0) === 0
    ? []
    : itinerary?.tours?.map((tour: any) => {
        const almostGuaranteed = tour.guaranteed_indicator?.includes("to G") ?? false;
        const type = tour.guaranteed_indicator == "G" ? "guaranteed" : "";
        const indicator = almostGuaranteed ? `${tour.guaranteed_indicator}o` : "";
        return {
          id: tour.id,
          code: tour.code,
          date: tour.departure_date,
          price: tour.price, type,
          location: tour.departure_location,
          indicator
        };
      });

    const goToTab = (key: string) => {
      hasUserSelectedTab.current = true;
      scrollIntoView("tour-details-tabs");

      setActiveTab(key);
    }

    return (
      <>
        <div className="headline">
          <div className="headline_banner">
            <ItineraryImages cover={itinerary?.coverImage} images={itinerary?.images || []}/>
          </div>
          <div className="headline_header"> 
            <div className="headline_title_row">
              <div id="show-page_header"> 
                <div className="caption-title-with-badge">
                  <h1>{selectedTour?.caption}</h1>
                  {
                    itinerary?.isNew && <span className="caption-new-badge">New</span>
                  }
                </div>
              </div>
              <div className="tour_details"> 
                <div className="tour_details_info">
                  <div className="tour_details_code">
                    <Icon path={mdiFileDocument} size="16px" />
                    <span>{selectedTour?.code}</span>
                  </div>
                  <span className="tour_details_category">Category: {itinerary?.category}</span>
                </div>
                <div className="tour_details_breadcrumb">
                  <Breadcrumb items={breadcrumbs} separator=">"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {
          itinerary && (
            <div id="itinerary-details">
              <ItineraryImages cover={itinerary.coverImage} images={itinerary.images}/>
              <Flex vertical style={{flex: 1}}>
                {
                  isMobile && isFixed && (
                    <div className={`tour-caption sticky ${isFixed ? "fixed" : ""}`}>
                      <a className="back-icon" href={`/web/listing?type=${type}`}> <Icon path={mdiChevronLeft} size={1} /> </a> 
                      <div className="caption-title-with-badge">
                        <h3> {selectedTour?.caption}</h3>
                        {
                          itinerary?.isNew && <span className="caption-new-badge">New</span>
                        }
                      </div>
                    </div>
                  )
                }
                <div id="tour-inclusives">
                  {
                    tourInclusives.filter(item => item.visible && !item.desktopOnly)
                      .map((item, index) => {
                        if (isMobile) {
                          if (item.tooltip) {
                            return (
                              <div 
                                key={index} 
                                className={`item ${item.tooltip ? 'clickable' : ''}`}
                                onClick={item.tooltip ? () => { setSelectedInclusion({icon: item.icon, label: item.label, tooltip: item.tooltip}); setIsInclusionModalOpen(true); } : undefined}
                              >
                                <div className="item-header">
                                  <div className="icon"> {item.icon} </div>
                                  <div className="item-label-group">
                                    <label>{item.label}</label>
                                    {item.content && <div className="item-description">{item.content()}</div>}
                                  </div>
                                  <span className="item-chevron"><Icon path={mdiChevronRight} size={1} /></span>
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <div key={index} className="item">
                                <div className="item-header">
                                  <div className="icon"> {item.icon} </div>
                                  <div className="item-label-group">
                                    <label>{item.label}</label>
                                    {item.content && <div className="item-description">{item.content()}</div>}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        } else {
                          if (item.tooltip) {
                            return (
                              <Popover
                                key={index}
                                color="white"
                                classNames={{ body: 'inclusives-tooltip-popover' }}
                                title={<div className="tooltip-title"> {item.icon} {item.label}</div>}
                                content={
                                  <div className="tooltip-content">
                                    {typeof item.tooltip === 'string' ? (
                                      <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                                        {item.tooltip}
                                      </Markdown>
                                    ) : (
                                      item.tooltip
                                    )}
                                  </div>
                                }>
                                  <div className="item with-tooltip">
                                    <div className="item-header">
                                      <div className="icon"> {item.icon} </div>
                                      <div className="item-label-group">
                                        <label><u>{item.label}</u></label>
                                        {item.content && <div className="item-description">{item.content()}</div>}
                                      </div>
                                    </div>
                                  </div>
                              </Popover>
                            );
                          } else {
                            return (
                              <div key={index} className="item">
                                <div className="item-header">
                                  <div className="icon"> {item.icon} </div>
                                  <div className="item-label-group">
                                    <label>{item.label}</label>
                                    {item.content && <div className="item-description">{item.content()}</div>}
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        }
                      })
                  }

                </div>

                <>
                  <div className="inclusives-highlight-separator" />
                  <DetailsSection header="Highlight" show={!!selectedTour?.highlight_customer}>
                    <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                      {selectedTour?.highlight_customer}
                    </Markdown>
                  </DetailsSection>
                </>
              </Flex>
            </div>
          )
        }

        {
          !loading && (
            <>
              <Layout style={layoutStyle} id="show-page_body" className={itinerary?.b2c2b ? "b2c2b" : ""}>
                <>
                  <Content>
                    {
                      itinerary && (
                        <>
                          <TourDateSelector2
                            dates={dates ?? []}
                            selectedDate={hasCabinNavigation ? (cruiseDeparture?.departure_date || "") : selectedDate}
                            selectedTourCode={hasCabinNavigation ? cruiseDeparture?.departure_date : selectedTour?.code}
                            selectTour={({date, code, id}) => hasCabinNavigation ? selectCruiseDeparture(date) : getItinerary(date, type, code, id)}
                            category={hasCabinNavigation ? CRUISE_CATEGORY : (itinerary?.category || "")}
                            isNew={!!itinerary?.isNew}/>

                          {
                            hasCabinNavigation && (
                              <CruiseCabinSelector
                                departure={cruiseDeparture}
                                priceCurrency={itinerary?.priceCurrency || "MYR"}
                                selectedMultiplier={cruiseMultiplier}
                                selectedTourId={cruiseTourId}
                                onSelectRoomType={selectCruiseRoomType}
                                onSelectCabin={selectCruiseCabin}
                                cabinSelectionDisabled={cruiseTourDetailLoading}
                              />
                            )
                          }

                          {
                            tourLoading ? (
                              <Space direction="vertical" style={{width: '100%'}}>
                                <Skeleton/>
                                <Skeleton/>
                                <Skeleton/>
                              </Space>
                            ) : (
                              <Tabs
                                centered
                                id="tour-details-tabs"
                                onChange={goToTab}
                                activeKey={activeTab}
                                items={[
                                  ...(itinerary?.itinerary_plans && itinerary?.itinerary_plans.length > 0 ? [{
                                    key: "itinerary",
                                    label: (
                                      <span className="itinerary-tab-label">
                                        Itinerary
                                        {itinerary?.is_itinerary_plans_preview_mode && (
                                          <span className="itinerary-tab-label__preview">Preview</span>
                                        )}
                                      </span>
                                    ),
                                    children: (
                                      <ItineraryTab
                                        plans={itinerary?.itinerary_plans ?? []}
                                        specialDisclaimer={itinerary?.special_disclaimer}
                                        isPreview={itinerary?.is_itinerary_plans_preview_mode}
                                        previewStatus={itinerary?.itinerary_plans_preview_status}
                                      />
                                    ),
                                  }] : []),
                                  {
                                    key: "description",
                                    label: "Description",
                                    children: (
                                      <>
                                        <h2>Description</h2>
                                        <div>
                                          <div id="description">
                                            <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{itinerary?.description}</Markdown>
                                          </div>
                                        </div>
                                      </>
                                    )
                                  },
                                  ...(selectedTour?.flights && selectedTour.flights.length > 0 ? [
                                    {
                                      key: "flights",
                                      label: "Schedule Flight(s)",
                                      children: (
                                        <>
                                          <h2>Schedule Flight(s)</h2>
                                          <Flex gap={20} vertical>
                                            {
                                              selectedTour?.flights.map((flight:any) => (
                                                <div className="schedule" key={flight.id}>
                                                  <div className="flight-destination">
                                                    <Icon path={mdiAirplane} size="17px" />
                                                    <label> {flight.from_airport} &gt; {flight.to_airport} </label>
                                                  </div>
                                                  <div className="flight-details">
                                                    <div className="flight-details_airline">
                                                      <img src={flight.airline_logo} />
                                                      <span>{flight.airline}</span>
                                                      <span className="flight-details_flight-no">{flight.flight_no}</span>
                                                    </div>
                                                    <div className="flight-details_datetime">
                                                      <div className="from">
                                                        <span className="flight-details_date">{flight.departure_date}, </span>
                                                        <span className="flight-details_time">{flight.departure_time}</span>
                                                        <span className="flight-details_location">{flight.from_airport}</span>
                                                      </div>
                                                      <div className="flight-details_datetime_icon">
                                                        <img src="/iceholidays-assets/images/plane.png" />
                                                      </div>
                                                      <div className="to">
                                                        <span className="flight-details_date">{flight.arrival_date}, </span>
                                                        <span className="flight-details_time">{flight.arrival_time}</span>
                                                        <span className="flight-details_location">{flight.to_airport}</span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            }
                                          </Flex>
                                        </>
                                      )
                                    }
                                  ] : []),
                                  {
                                    key: "price-table",
                                    label: "Price Table",
                                    children: (
                                      <>
                                        <h2>Price Details</h2>
                                        <PriceTable isB2C2B={itinerary.b2c2b} priceCurrency={itinerary?.priceCurrency || "MYR"} prices={selectedTour?.prices || []} roomTypes={selectedTour?.room_types}/>
                                      </>
                                    )
                                  },
                                  ...(itinerary && itinerary.b2c2b ? [
                                    {
                                      forceRender: true,
                                      key: "booking-form",
                                      label: "Booking Form",
                                      children: BookingForm()
                                    }
                                  ] : []),
                                  {
                                    key: "booking-notice",
                                    label: "Booking Notice",
                                    children: <BookingNoticeTab />
                                  },
                                ]}
                                />
                            )
                          }

                        </>
                      )
                    }
                  </Content>
                  {isMobile && (showContactAgent || showTravelers) && (
                    <div className="side-widget-backdrop" onClick={() => { setShowContactAgent(false); setShowTravelers(false); }} />
                  )}
                  {!isMobile && travelersAnimating && (
                    <div className="travelers-overlay" onClick={() => setTravelersAnimating(false)} />
                  )}
                  <Sider width="285px" style={siderStyle} className={`contact-agent-sider side-widget-sider ${showContactAgent ? "show-contact-agent-mobile" : ""} ${showTravelers ? "show-travelers-mobile" : ""} ${travelersAnimating ? "travelers-animating" : ""}`} onClick={() => { if (travelersAnimating) setTravelersAnimating(false); }}>
                    <Flex vertical gap={10}>

                      <div className="toggle-travelers toggle-side-widget" onClick={toggleTravelers}> 
                        <span>Travelers{selectedTravelers.length > 0 ? ` - ${selectedTravelers.length} Pax` : ""}</span>
                      </div>

                      {
                        !itinerary?.b2c2b && (
                          <div className="toggle-contact-agent toggle-side-widget" onClick={toggleContactAgent}> 
                            <span>Contact Agent</span>
                          </div>
                        )
                      }
                      
                      {itinerary?.b2c2b && (
                        hasCabinNavigation ? (
                          isMobile ? (
                            <div className="travelers side-widget">
                              <div className="travelers_header side-widget_header">
                                <span>Cabin &amp; Travelers </span>
                                <Button className="collapse-travelers" color="default" variant="text"
                                  icon={<Icon path={mdiClose} size="19px" />}
                                  onClick={toggleTravelers}/>
                              </div>
                              <div className="travelers_content side-widget_content">
                                <CruiseTravelers
                                  cabins={cruiseCabins}
                                  setCabins={setCruiseCabins}
                                  multiplier={cruiseMultiplier || 0}
                                  maxCabins={maxCruiseCabins}
                                  disabled={!cruiseMultiplier || !cruiseTourId}
                                  childAgeRanges={itinerary?.child_age_ranges}
                                />
                              </div>
                            </div>
                          ) : (
                            <Affix offsetTop={0}>
                              <div className="travelers side-widget" ref={travelersWidgetRef}>
                                <div className="travelers_header side-widget_header">
                                  <span>Cabin &amp; Travelers </span>
                                  <Button className="collapse-travelers" color="default" variant="text"
                                    icon={<Icon path={mdiClose} size="19px" />}
                                    onClick={toggleTravelers}/>
                                </div>
                                <div className="travelers_content side-widget_content">
                                  <CruiseTravelers
                                    cabins={cruiseCabins}
                                    setCabins={setCruiseCabins}
                                    multiplier={cruiseMultiplier || 0}
                                    maxCabins={maxCruiseCabins}
                                    disabled={!cruiseMultiplier || !cruiseTourId}
                                    childAgeRanges={itinerary?.child_age_ranges}
                                  />
                                </div>
                              </div>
                            </Affix>
                          )
                        ) : (
                        isMobile ? (
                        <div className="travelers side-widget">
                          <div className="travelers_header side-widget_header">
                            <span>Travelers </span>
                            <Button className="collapse-travelers" color="default" variant="text" 
                              icon={<Icon path={mdiClose} size="19px" />}
                              onClick={toggleTravelers}/>
                          </div>
                          <div className="travelers_content side-widget_content">
                            <Travelers
                              travelerCounts={travelerCounts}
                              setTravelerCounts={setTravelerCounts}
                              selectedTravelers={selectedTravelers}
                              setSelectedTravelers={setSelectedTravelers}
                              paxMultiplier={paxMultiplier}
                              maxBookingSeats={maxBookingSeats}
                              pricingCategories={pricingCategory(selectedTour?.room_types || type)}
                              b2c2b={itinerary?.b2c2b || false}
                              bookingForm={bookingForm}
                              bookingInputParams={bookingInputParams as BookingInput}
                              childAgeRanges={itinerary?.child_age_ranges}
                            />
                          </div>
                        </div>
                      ) : (
                        <Affix offsetTop={0}>
                          <div className="travelers side-widget" ref={travelersWidgetRef}>
                            <div className="travelers_header side-widget_header"> 
                              <span>Travelers </span>
                              <Button className="collapse-travelers" color="default" variant="text" 
                                icon={<Icon path={mdiClose} size="19px" />}
                                onClick={toggleTravelers}/>
                            </div>
                            <div className="travelers_content side-widget_content">
                              <Travelers
                                travelerCounts={travelerCounts}
                                setTravelerCounts={setTravelerCounts}
                                selectedTravelers={selectedTravelers}
                                setSelectedTravelers={setSelectedTravelers}
                                paxMultiplier={paxMultiplier}
                                maxBookingSeats={maxBookingSeats}
                                pricingCategories={pricingCategory(selectedTour?.room_types || type)}
                                b2c2b={itinerary?.b2c2b || false}
                                bookingForm={bookingForm}
                                bookingInputParams={bookingInputParams as BookingInput}
                                childAgeRanges={itinerary?.child_age_ranges}
                              />
                            </div>
                          </div>
                        </Affix>
                        )
                      ))}


                      {
                        !itinerary?.b2c2b && (
                          <div className="contact-agent side-widget">
                            <div className="contact-agent_header side-widget_header"> 
                              <span>Contact Agent</span>
                              <Button className="collapse-contact-agent" color="default" variant="text" 
                                icon={<Icon path={mdiClose} size="19px" />}
                                onClick={toggleContactAgent}/>
                            </div>
                            <div className="contact-agent_content side-widget_content"> 
                              <ContactAgentsForm 
                                states={states} 
                                cities={cities} 
                                findAgents={findAgents} 
                                filterCities={filterCities}
                                filterStates={filterStates}/>

                              {
                                showAgentsResults && (
                                  <div className="search-results">
                                    <Flex vertical gap={20}>
                                      {
                                        agents.length > 0 && agents.map((agent:Agent) => {
                                          return (
                                            <Row key={agent.id} gutter={2} justify="space-between" className="agent-info">
                                              <Col flex="180px"><span className="company" onClick={()=>showModal(agent)}>
                                                {agent.name}</span>
                                              </Col>
                                              <Col flex="none"><Button href={whatsappLink(agent.whatsapp!)} target="_blank" color="default" variant="filled" shape="circle" size="small" icon={<Icon path={mdiPhoneInTalkOutline} size="16px" />}/></Col>
                                              <Col flex="none"><Button href={emailLink(agent.email)} target="_blank" color="default" variant="filled" shape="circle" size="small" icon={<Icon path={mdiEmailOutline} size="16px" />}/></Col>
                                              <Col>
                                                <div className="contact-numbers">
                                                  <Button size="small" color="primary" variant="outlined">
                                                    <Icon path={mdiWhatsapp} size="12px" />
                                                    {agent.whatsapp}
                                                  </Button>
                                                </div>
                                              </Col>
                                            </Row>
                                          );
                                        })
                                      }
                                    </Flex>
                                  </div>
                                )
                              }
                            </div>
                          </div>
                        )
                      }
                    </Flex>
                  </Sider>
                </>
              </Layout>

              {
                itinerary && (
                  <Affix offsetBottom={0}>
                    <div className="pricing-summary-footer">
                      {selectedTour?.departure_date && (
                        <div className="pricing-summary-footer_departure-date">
                            <span className="pricing-summary-footer_departure-date_label">Departure Date: {safeFormatDate(selectedTour.departure_date)}</span>
                          </div>
                        )}
                        <div className="pricing-summary-footer_price-row">
                          <div className="pricing-summary-footer_details">
                            <Flex gap={20} align="center" justify="space-between" className="pricing-summary-footer_details_total">
                              <span className="pricing-summary-footer_details_label">Total</span>
                              <span className="pricing-summary-footer_details_value">
                                {promotionCalcLoading ? <Spin size="small" /> : currencyGrandTotal}
                              </span>
                              {
                                selectedTravelers.length > 0 && (
                                  <>
                                    <Drawer
                                      title="Price Details"
                                      placement="bottom"
                                      onClose={() => setOpen(false)}
                                      open={open}
                                      height="auto"
                                      className="mobile-price-drawer"
                                      closable                                     
                                    >
                                    <PricingSummary2
                                      summary={pricingSummary} 
                                      addOns={bookingAddons}
                                      showAdminFee={showAdminFee}
                                      currencyAdminFee={currencyAdminFee}
                                      currencyGrandTotal={currencyGrandTotal}
                                      currencyAddOnsTotal={currencyAddOnsTotal}
                                      showNonMalaysiaCharge={nonMalaysiaChargeAmount > 0}
                                      currencyNonMalaysiaCharges={currencyNonMalaysiaCharges}
                                      showVisaFee={showVisaFee}
                                      currencyVisaFee={currencyVisaFee}
                                      promotionDeductions={promotionDeductionRows}
                                      loading={promotionCalcLoading}
                                      cabin={hasCabinNavigation ? cruiseCabins.length : undefined}
                                      currencyDeposit={currencyDeposit}
                                      dueDate={depositDueDate}
                                      depositPaymentSelected={depositDetailsVisible}
                                      currencyBalance={currencyBalance}
                                      />
                                    </Drawer>

                                    <span className="mobile-price-drawer-toggle" onClick={()=>setOpen(true)}><Icon path={mdiInformationOutline} size={1} /></span>
                                    
                                    <Popover
                                      classNames={{ body: 'pricing-summary-popover' }} 
                                      title="Price Details" 
                                      content={
                                        <PricingSummary2
                                          summary={pricingSummary} 
                                          addOns={bookingAddons}
                                          showAdminFee={showAdminFee}
                                          currencyAdminFee={currencyAdminFee}
                                          currencyGrandTotal={currencyGrandTotal}
                                          currencyAddOnsTotal={currencyAddOnsTotal}
                                          showNonMalaysiaCharge={nonMalaysiaChargeAmount > 0}
                                          currencyNonMalaysiaCharges={currencyNonMalaysiaCharges}
                                          showVisaFee={showVisaFee}
                                          currencyVisaFee={currencyVisaFee}
                                          promotionDeductions={promotionDeductionRows}
                                          loading={promotionCalcLoading}
                                          cabin={hasCabinNavigation ? cruiseCabins.length : undefined}
                                          currencyDeposit={currencyDeposit}
                                          dueDate={depositDueDate}
                                          depositPaymentSelected={depositDetailsVisible}
                                          currencyBalance={currencyBalance}
                                          />
                                      }>
                                      <span className="price-drawer-toggle"><Icon path={mdiInformationOutline} size={1} /></span>
                                    </Popover>
                                  </>
                                )
                              }
                            </Flex>
                            <small> (incl. taxes & fees) </small>
                          </div>

                          <Flex gap={8} align="center" style={{ flexShrink: 0 }}>
                            <Tooltip title="Share itinerary" placement="top">
                              <Button
                                shape="circle"
                                size="middle"
                                style={{ backgroundColor: '#f5f5f5', border: 'none', flexShrink: 0 }}
                                icon={<Icon path={mdiShareVariant} size="20px" color="#000" />}
                                onClick={handleShareLink}
                              />
                            </Tooltip>
                            {
                              itinerary.b2c2b ? (
                                activeTab === "booking-form" ? (
                                  selectedTravelers.length === 0 ? (
                                    <Button
                                      color="primary"
                                      variant="filled"
                                      className="booking-form-checkout-button"
                                      onClick={() => isMobile ? setShowTravelers(true) : highlightTravelers()}
                                    >
                                      Select Traveler
                                    </Button>
                                  ) : (
                                    <Tooltip
                                      title={itinerary.checkoutEnabled === false ? itinerary.checkoutDisabledMessage : ""}
                                      placement="top"
                                    >
                                      <span>
                                        <Button
                                          onClick={() => bookingForm.submit()}
                                          color="primary"
                                          variant="filled"
                                          className="booking-form-checkout-button"
                                          disabled={itinerary.checkoutEnabled === false || promotionCalcLoading || cruiseTourDetailLoading}
                                          loading={cruiseTourDetailLoading}
                                        >
                                          Check Out
                                        </Button>
                                      </span>
                                    </Tooltip>
                                  )
                                ) : (
                                  <Button
                                    color="primary"
                                    variant="filled"
                                    className="booking-form-checkout-button"
                                    disabled={promotionCalcLoading}
                                    onClick={() => { scrollIntoView("tour-details-tabs"); setActiveTab("booking-form"); if (isMobile) setShowTravelers(true); else if (selectedTravelers.length === 0) highlightTravelers(); }}
                                  >
                                    Next
                                  </Button>
                                )
                              ) : 
                              <Tooltip title="Tour is not open for booking. For more information, please kindly contact customer service.">
                                <span>
                                  <Button
                                    disabled
                                    color="primary" 
                                    variant="filled"
                                    className="booking-form-checkout-button"
                                  >
                                    Next
                                  </Button>
                                </span>
                              </Tooltip>
                            }
                          </Flex>
                        </div>
                    </div>
                  </Affix>
                )
              }
            </>
          )
        }
      </>
    );
  }

  const [flightArrowLeft, setFlightArrowLeft] = React.useState<number>(65);

  // After each selectedTour change, measure the selected date card's center
  // relative to the .flights container so the arrow tracks the active card.
  React.useEffect(() => {
    const section = document.getElementById("departure-date");
    if (!section) return;
    const selectedBox = section.querySelector(".tour-date-box.selected") as HTMLElement | null;
    const flightsEl = section.querySelector(".flights") as HTMLElement | null;
    if (!selectedBox || !flightsEl) return;
    const boxRect = selectedBox.getBoundingClientRect();
    const flightsRect = flightsEl.getBoundingClientRect();
    const center = boxRect.left + boxRect.width / 2 - flightsRect.left;
    // Subtract half the arrow base width (9px) so the tip centres on the card
    setFlightArrowLeft(Math.max(9, Math.round(center - 9)));
  }, [selectedTour]);

  // On caption change, collapse the title and measure (in one layout effect, before paint)
  // whether it overflows the 3-line clamp. Uses scrollHeight so the measurement holds even
  // if the title was left expanded by a previous tour.
  useLayoutEffect(() => {
    setShowV3ReadMore(false);
    const el = v3TitleRef.current;
    if (!el) { setV3TitleClamped(false); return; }
    const cs = getComputedStyle(el);
    let lineHeight = parseFloat(cs.lineHeight);
    if (!Number.isFinite(lineHeight)) lineHeight = parseFloat(cs.fontSize) * 1.4;
    setV3TitleClamped(el.scrollHeight > lineHeight * 3 + 1);
  }, [selectedTour?.caption]);

  const V3Layout = () => {
    const dates = hasCabinNavigation
      ? (itinerary?.cabinNavigation?.departures || []).map((departure) => ({
          id: undefined,
          code: departure.departure_date,
          date: departure.departure_date,
          price: currencyDisplay(itinerary?.priceCurrency || "MYR", departure.from_price),
          type: departure.guaranteed ? "guaranteed" : "",
          location: "",
          indicator: "",
          promoTag: undefined
        }))
      : (itinerary?.tours?.length || 0) === 0
      ? []
      : itinerary?.tours?.map((tour: any) => {
          const almostGuaranteed = tour.guaranteed_indicator?.includes("to G") ?? false;
          const tourType = tour.guaranteed_indicator == "G" ? "guaranteed" : "";
          const indicator = almostGuaranteed ? `${tour.guaranteed_indicator}o` : "";
          return { id: tour.id, code: tour.code, date: tour.departure_date, price: tour.price, type: tourType, location: tour.departure_location, indicator, promoTag: tour.promo_tag };
        });

    const promoPrice = selectedTour?.prices?.find((p: any) => p.type?.startsWith("promo"));
    const normalPrice = selectedTour?.prices?.find((p: any) => p.type === "normal");
    // selectedTour.price is already currency-formatted where it exists (regular series tours).
    // Cruise cabin tours never have a top-level .price at all, so fall back to the same
    // prices[] source PromoBannerV3 uses, formatted the same way everything else on the page is.
    const basePrice = selectedTour?.price
      ? String(selectedTour.price)
      : (promoPrice || normalPrice)?.adult != null
        ? currencyDisplay(itinerary?.priceCurrency, (promoPrice || normalPrice).adult)
        : null;

    const highlightWavySvg = (
      <div className="highlight-wavy-svg">
        <svg xmlns="http://www.w3.org/2000/svg" width="81" height="13" viewBox="0 0 81 13" fill="none">
          <path opacity="0.6" d="M7.31909 11.0246C7.36867 11.0056 7.57885 10.9703 7.66737 10.9457C7.58381 11.0381 7.14026 11.0933 7.31909 11.0246ZM15.1287 3.61104C15.0599 3.64948 14.9911 3.68787 14.9223 3.72622C15.1339 3.67879 15.4108 3.58648 15.6086 3.5484C15.641 3.54226 15.5723 3.61682 15.6478 3.59791C15.7233 3.57897 15.6906 3.51291 15.7975 3.47445C15.9176 3.43154 16.4897 3.32137 16.683 3.26485C16.9894 3.17521 17.295 3.07852 17.6013 2.98299C18.0181 2.85304 18.4356 2.72389 18.8573 2.61747C18.1237 2.89156 18.8913 2.72421 19.0945 2.63875C19.1394 2.61934 19.0971 2.48762 19.8547 2.29525C20.336 2.17236 19.948 2.50297 20.7159 2.1626C20.0698 2.21081 20.6724 2.03782 21.1488 1.88451C21.231 1.85827 21.9013 1.67191 22.193 1.57289C22.2929 1.53912 22.4263 1.41595 22.5588 1.37151C22.6501 1.34101 22.73 1.36007 22.8655 1.31464C23.4969 1.10317 24.1187 0.898471 24.7565 0.706784C24.4382 1.02787 25.0698 0.698768 25.102 0.698558C25.2675 0.705012 24.5879 0.940652 24.8672 0.887911C25.2435 0.760408 25.6197 0.632287 25.9957 0.503697C25.7592 0.559773 26.08 0.360906 26.3197 0.265953C26.4815 0.212766 26.6242 0.182225 26.6947 0.184448C26.6121 0.109254 27.5132 -0.0910325 28.5098 0.0472403C29.5113 0.158757 30.4783 0.644993 30.739 0.744946C30.7954 0.764178 30.6608 0.668848 30.7113 0.670013C30.7557 0.679732 31.0242 0.734649 31.7515 1.27332C31.9058 1.39397 31.8077 1.3971 31.892 1.45504C31.9391 1.48727 32.3677 1.57967 32.5726 1.94531C32.6093 2.0106 32.4406 1.89888 32.4474 1.94917C32.4442 2.00861 32.6731 2.16859 33.2674 3.00191C33.1204 2.62697 33.5581 3.12313 33.8973 3.93263C34.2544 4.73718 34.3638 5.83136 34.3344 6.25367C34.3333 6.25318 34.3322 6.25272 34.3309 6.25232C34.3361 6.25273 34.3413 6.25318 34.3465 6.25367C34.3653 6.1472 34.3814 6.04011 34.3948 5.93254C34.3906 6.05723 34.3865 6.16298 34.3837 6.25367C34.3714 6.24512 34.42 6.237 34.4199 6.23178C34.4197 6.20433 34.3615 6.17461 34.3699 6.14258C34.3794 6.10442 34.4923 6.03308 34.4371 6.00877C34.4636 6.00333 34.4911 6.00025 34.5191 5.9996C34.5036 5.96037 34.4839 5.92507 34.4606 5.89348C34.3668 6.09647 34.4514 5.88476 34.4441 5.87219C34.4422 5.85699 34.4036 5.92674 34.4004 5.9039C34.4 5.90103 34.4463 5.85051 34.4308 5.81708C34.3938 5.74798 34.3564 5.8335 34.3381 5.81312C34.3353 5.81094 34.3741 5.76117 34.3325 5.7126C34.1745 5.56864 34.3258 5.75748 34.3182 5.76985C34.3148 5.78463 34.2011 5.99785 34.2894 5.98327C34.2576 5.98362 34.2068 6.08713 34.2048 6.08754C34.205 6.08809 34.1876 6.04241 34.1847 6.03697C34.1771 5.98416 34.2122 5.92008 34.2124 5.90348C34.206 5.88718 34.1401 5.95662 34.1178 5.71204C34.0756 5.92431 34.1439 5.91689 34.1796 5.97983C34.1744 6.02698 34.1285 6.0442 34.1273 6.04411C34.0762 6.01867 34.0945 5.85 34.0685 5.7283C34.0492 5.66496 34.0171 5.7854 34.041 5.62598C33.9245 5.60294 34.014 5.70041 34.0074 5.71374C34.0055 5.72205 33.9976 5.71851 33.9887 5.71225C34.0565 5.68418 34.1266 5.64942 34.1419 5.64893C34.1807 5.64779 34.067 5.73906 34.216 5.71837C34.2406 5.71461 34.4497 5.55345 34.1391 5.59161C34.5426 5.49304 34.4898 5.42034 34.6656 5.54811C34.8656 5.15813 34.9105 5.67821 35.0234 5.66617C35.3237 5.63385 35.1802 5.40968 35.1926 5.39345C35.2789 5.28684 36.1001 5.15533 36.2901 5.0674C36.255 5.2673 35.6554 5.2392 35.5395 5.30805C35.1524 5.53531 36.1459 5.23973 35.8988 5.54564C36.0103 5.4502 36.1218 5.35473 36.2333 5.25928C36.5002 5.34295 36.1863 5.49246 36.798 5.27592C36.8698 5.12368 36.3613 5.41138 36.4465 5.28416C36.4968 5.20923 36.8558 5.10184 36.8556 5.06948C36.8538 5.03072 36.5371 5.16017 36.5751 5.09012C36.6579 4.93727 37.8805 4.74467 36.9874 5.04686C37.2404 4.97882 37.43 5.18895 37.6318 5.05691C37.7623 4.9715 36.8799 4.83798 38.0966 4.59474C38.15 4.70345 37.6242 4.75025 37.6133 4.76264C37.5979 4.78009 37.7522 5.01673 37.7712 5.02557C37.8343 5.05142 38.9277 4.64539 39.28 4.67079C39.2964 4.67191 39.3112 4.67394 39.3242 4.67698C39.1848 4.5509 40.2479 4.42637 40.3495 4.354C40.3764 4.33419 40.2421 4.26865 40.2718 4.25125C40.4576 4.14539 41.0381 4.18173 41.2901 4.12689C41.5721 4.06553 41.5174 3.99443 41.5331 3.99088C41.6578 3.96629 41.572 4.0434 41.6476 4.0255C41.7616 3.99823 42.549 3.82618 42.5857 3.80601C42.5964 3.79984 42.4463 3.73888 42.6133 3.68201C42.6423 3.67224 42.6493 3.78376 43.1451 3.62046C43.7422 3.4243 42.6889 3.58455 42.9154 3.41375C43.3463 3.48361 43.2953 3.32809 43.4047 3.31621C43.4426 3.31234 43.7492 3.38422 44.045 3.30798C43.8365 3.37839 43.6281 3.44903 43.4197 3.51991C43.6354 3.49527 44.0364 3.37298 44.216 3.36032C44.3036 3.35409 44.2606 3.48021 44.4434 3.43553C44.482 3.42547 44.5716 3.12173 44.1201 3.35138C44.0585 3.26408 44.3023 3.27467 44.4019 3.22354C44.4169 3.21566 44.4415 3.04118 44.6011 3.11017C44.6396 3.12748 44.3979 3.67373 45.2303 3.13033C45.2571 3.11287 45.1406 3.07748 45.1665 3.05893C45.1842 3.04632 45.4232 3.01771 45.447 3.0037C45.4713 2.98895 45.3432 2.95048 45.3716 2.93095C45.517 2.83066 45.7892 3.03557 45.4526 3.09054C45.5711 3.0969 45.6896 3.10326 45.808 3.10962C45.6434 2.94625 45.9694 3.01737 46.1215 2.97742C47.0969 2.7223 46.4081 2.7453 46.5619 2.64428C46.8096 2.48262 46.6796 2.85119 47.0605 2.66561C47.0867 2.6528 46.8041 2.63276 47.0597 2.56925C47.1715 2.54192 47.363 2.50526 47.6776 2.46762C47.4993 2.50601 47.3216 2.54731 47.1441 2.59168C47.289 2.74914 47.7858 2.4493 47.829 2.44142C48.3023 2.33824 47.9893 2.44887 48.6846 2.25964C48.747 2.24331 48.8911 2.27249 49.0235 2.23604C49.5749 2.0839 48.2738 2.2599 48.2242 2.20258C48.2013 2.15512 49.6171 2.01182 49.6651 2.0401C49.8766 2.10098 49.0313 2.12263 49.2024 2.20661C49.2663 2.20945 51.246 2.06569 51.6321 2.14805C52.0836 2.21024 52.2698 2.47426 52.2857 2.19769C52.3987 2.47779 52.5172 2.30229 52.5743 2.30929C52.8346 2.34202 52.9942 2.36635 53.1254 2.38409C53.3383 2.41374 53.4761 2.42471 53.8339 2.46168C53.9617 2.47528 54.0578 2.57295 54.104 2.56664C54.131 2.56276 54.0937 2.46856 54.2247 2.46349C54.4104 2.45085 55.4444 2.75247 55.5082 2.82152C55.5763 2.88449 55.0675 2.74456 55.1458 2.84196C55.5163 2.92894 55.873 2.99445 56.2377 3.09886C56.3889 3.14269 56.2987 3.17448 56.364 3.19305C56.3922 3.1997 56.9231 3.30096 56.9057 3.27669C56.8724 3.20435 55.2325 2.82136 55.681 2.83771C55.7691 2.8393 56.0372 3.03466 56.0221 2.87495C56.9857 3.14283 57.9166 3.46596 58.817 3.83096C59.1944 3.99037 59.5885 4.14944 59.9721 4.29966C59.5858 4.22428 59.1805 4.07013 58.7926 3.90472C58.4257 3.75465 58.0532 3.60554 57.6821 3.48827C57.5663 3.45049 57.1746 3.31277 57.2032 3.40107C57.6933 3.56507 58.2628 3.74485 58.779 3.94588C58.9762 4.0251 59.1795 4.10866 59.3511 4.18901C59.3686 4.19721 59.2827 4.23531 59.3471 4.27029C59.4691 4.33644 59.9128 4.38549 59.976 4.4364C59.9859 4.44666 59.7246 4.44408 59.7807 4.52207C59.9248 4.72154 60.0652 4.44314 60.2193 4.50185C60.338 4.54964 61.1354 4.97375 61.3656 4.9493C61.6111 4.92738 60.7662 4.69199 60.8494 4.63314C61.4316 4.74588 61.9863 5.01404 62.5249 5.16652C62.5345 5.16919 62.4658 5.08442 62.5885 5.11277C62.8033 5.16228 62.8352 5.26167 62.9349 5.30531C63.0419 5.35242 63.4357 5.45268 63.481 5.4972C63.4868 5.50302 63.39 5.56323 63.3775 5.5622C63.2009 5.54866 63.1628 5.42334 63.1476 5.41748C63.0899 5.39652 63.0232 5.4212 62.9706 5.40332C62.8842 5.37379 62.8449 5.32142 62.7318 5.28413C62.6537 5.2582 62.7131 5.35479 62.6371 5.32863C62.6079 5.31902 62.3456 5.05779 62.2765 5.22232C62.2511 5.28967 64.733 6.05013 65.0012 6.05483C64.7862 5.98155 64.5746 5.90712 64.3646 5.83129C64.79 5.99333 65.3429 5.99069 65.3471 6.19208C66.9801 6.59517 68.6406 6.92119 70.3193 7.16404C70.6188 7.21849 70.4461 7.30425 70.9443 7.33435C70.8172 7.28545 70.6911 7.23562 70.5659 7.1849C70.8153 7.24608 71.9439 7.41877 72.1255 7.4127C72.1493 7.41221 72.1833 7.32535 72.466 7.34553C72.7181 7.36305 72.7557 7.43263 72.8898 7.45683C73.0021 7.47688 73.1289 7.47002 73.1624 7.47632C73.1882 7.48126 73.1984 7.52182 73.2605 7.53345C73.4567 7.56928 73.2979 7.44703 73.4923 7.58804C73.4455 7.58955 73.3981 7.59103 73.3505 7.59248C73.5867 7.62844 73.9093 7.70441 73.5622 7.71115C73.5026 7.71223 73.5534 7.6777 73.509 7.67485C71.7621 7.55227 73.1556 7.73764 73.7691 7.71291C73.9281 7.77972 74.8116 7.78622 74.8425 7.79624C74.8843 7.81258 74.7333 7.84985 74.9347 7.89236C74.9764 7.90445 76.1649 7.89625 75.7397 7.95612C75.6505 7.96984 75.0816 7.94456 74.9437 7.94182C75.2703 8.06168 76.0247 7.91388 76.1078 7.91908C76.4525 7.93665 75.4538 8.00733 76.2288 8.02148C76.8278 8.02807 76.2609 7.96213 76.489 7.93227C76.6189 7.91764 77.2973 7.98147 77.2719 7.88805C77.5037 7.87439 77.3721 7.92525 77.4011 7.92829C77.431 7.93088 77.8819 7.89332 78.0328 7.90655C78.0511 7.90823 77.9993 7.95602 78.0183 7.95914C78.0548 7.96478 78.4971 7.93721 78.513 7.93242C78.5239 7.9294 78.4148 7.89491 78.4566 7.88365C78.5051 7.87129 78.9296 7.86094 78.952 7.84851C78.9825 7.83129 78.4613 7.86536 78.5433 7.818C78.7841 7.82004 79.1763 7.77219 79.3301 7.73137C79.2933 7.7427 79.0581 7.75571 78.9765 7.75572C79.0073 7.693 79.5088 7.67134 79.344 7.72642C79.4491 7.69566 79.3731 7.68595 79.431 7.65921C79.4461 7.65249 79.6005 7.64371 79.629 7.63205C79.6325 7.62998 79.4698 7.61542 79.5001 7.60189C79.5543 7.57827 80.0253 7.55998 80.0653 7.56251C80.1763 7.57174 79.7944 7.61194 79.7663 7.63785C79.7621 7.64241 80.0962 7.66998 80.1021 7.67315C80.1279 7.7162 79.7588 7.70756 79.8066 7.74527C79.8978 7.74815 79.9891 7.75057 80.0807 7.75254C79.7378 7.8194 79.0977 7.83441 78.937 7.89219C79.4511 7.85061 79.9855 7.81463 80.0016 7.91741C80.0079 7.9611 79.7892 8.00578 79.7995 8.01638C79.8381 8.05429 80.141 7.98307 80.1529 7.98415C80.1626 7.98569 80.1673 7.98762 80.1677 7.98989C80.1677 7.98989 80.1677 7.98989 80.1677 7.98989C80.1677 7.98989 80.1677 7.98989 80.1677 7.98989C80.1677 7.98989 80.1677 7.98989 80.1677 7.98989C80.171 8.01316 79.7325 8.06976 79.7124 8.08219C79.6781 8.10515 79.8857 8.16661 79.8881 8.18362C79.8816 8.18791 79.5709 8.23701 79.6811 8.25777C79.7924 8.27879 80.068 8.24975 80.0782 8.25171C80.1334 8.26431 79.6544 8.3329 79.642 8.34502C79.6351 8.35175 79.8983 8.35805 79.9074 8.36651C79.9152 8.37553 79.7219 8.41891 79.6491 8.4589C79.5948 8.48882 79.7652 8.48737 79.7362 8.49434C79.715 8.49983 79.2624 8.55005 79.239 8.55634C79.2063 8.56626 79.3174 8.58329 79.3028 8.5921C79.282 8.60496 79.1328 8.61075 79.1535 8.61933C79.1699 8.62747 79.7524 8.65714 79.7527 8.68113C79.7522 8.72581 79.135 8.70357 79.7207 8.80299C79.7248 8.80359 79.86 8.7722 79.864 8.77269C79.9533 8.7914 79.5203 8.90478 80.0572 8.81658C79.065 9.01828 79.9418 8.90113 79.8045 8.99552C79.7509 9.03291 79.3665 9.10378 79.3638 9.1083C79.4073 9.1395 79.5265 9.09218 79.571 9.10353C79.596 9.10984 79.2527 9.2025 79.3344 9.21593C79.3782 9.22296 79.745 9.15898 79.7609 9.15855C79.9103 9.15742 79.7348 9.21258 79.7692 9.22382C79.7921 9.23149 80.0153 9.19337 80.0214 9.19415C80.0314 9.19657 79.7349 9.29449 79.6742 9.32139C79.628 9.34213 79.8106 9.32948 79.7779 9.34064C79.5814 9.40911 79.1393 9.40052 79.5699 9.44423C79.596 9.44686 79.7519 9.41556 79.7568 9.41605C79.858 9.43037 79.5704 9.48637 79.5227 9.52245C79.4405 9.58529 79.8508 9.48212 79.5111 9.57896C79.7734 9.5608 79.9175 9.53088 80.22 9.46128C79.3837 9.64977 79.1046 9.83084 80.0358 9.6376C79.7387 9.6974 79.7812 9.7566 79.6929 9.77625C79.6391 9.78894 79.1961 9.80696 79.4154 9.92002C79.4435 9.93405 79.7021 9.85504 79.6253 9.91073C78.9918 10.0328 79.6168 9.93866 79.6167 9.94298C79.6221 10.0399 78.0619 10.2759 77.7966 10.3231C77.4861 10.3896 77.2161 10.5158 77.1485 10.5271C76.926 10.5629 77.1072 10.4913 77.0562 10.4838C77.0069 10.4768 76.3736 10.6541 76.3421 10.6536C76.2178 10.6526 76.3393 10.5829 76.3263 10.5822C76.1742 10.5733 75.317 10.7228 75.0771 10.7346C75.0876 10.7703 75.5673 10.7161 75.2699 10.8088C74.9216 10.9175 74.8937 10.7597 74.8847 10.7537C73.2758 10.9253 71.6514 11.0098 70.026 11.0079C70.041 11.1137 71.1102 11.0243 71.1316 11.0344C71.2739 11.1144 69.4686 11.1335 69.2526 11.0829C69.4207 11.1085 69.5836 11.1325 69.7507 11.1555C69.4569 11.2757 68.8314 11.1101 68.4124 11.1492C68.2759 11.1627 68.5305 11.2187 68.525 11.2215C68.3682 11.2656 68.1292 11.2202 68.3169 11.1614C67.9417 11.2107 68.0043 11.1439 67.7219 11.1258C67.7073 11.1249 67.8239 11.1816 67.5966 11.1922C67.4888 11.1979 66.9337 11.1673 66.8504 11.2071C66.8166 11.2249 67.079 11.4425 67.1336 11.2711C67.7325 11.3858 67.3367 11.203 67.5731 11.2187C67.6081 11.2206 67.5191 11.3152 68.1164 11.2918C67.9873 11.4592 67.3093 11.3035 67.191 11.3165C66.9413 11.3492 67.9386 11.4832 68.1335 11.3534C68.0346 11.4828 68.2025 11.3737 68.4265 11.3848C68.6725 11.3965 68.5605 11.4327 68.6928 11.4354C69.0539 11.4415 68.9111 11.3489 69.204 11.4334C68.9334 11.1784 69.7145 11.4053 69.946 11.464C69.5642 11.4807 69.1836 11.4931 68.8013 11.5012C68.8219 11.5148 68.8425 11.5285 68.8631 11.5421C68.763 11.5392 68.6632 11.5359 68.5637 11.5324C68.5808 11.5197 68.5979 11.5071 68.6151 11.4944C68.0878 11.5693 67.9715 11.468 67.9298 11.4658C67.3876 11.4374 66.7585 11.4056 66.2125 11.3668C66.1305 11.3601 66.171 11.4568 65.5834 11.3382C65.3965 11.2995 65.5872 11.2444 65.368 11.2356C65.0659 11.4038 65.0954 11.2501 65.0152 11.242C64.7861 11.2198 64.6348 11.2528 64.6133 11.2512C64.3251 11.229 63.9091 11.173 63.594 11.1403C63.588 11.1404 63.7393 11.222 63.5395 11.1784C63.4697 11.1645 62.8834 10.816 62.3057 10.8119C62.4463 10.8529 62.5887 10.8934 62.7314 10.933C62.5623 10.8859 61.3542 10.7555 61.6295 10.8762C61.7993 10.9511 62.2763 10.8484 62.2878 11.0214C61.8981 10.9245 59.6814 10.584 59.5257 10.4951C59.5045 10.4844 59.6625 10.4593 59.6323 10.4452C59.6113 10.4357 59.1015 10.3363 59.0446 10.2995C59.009 10.2777 59.2376 10.2932 59.2256 10.2689C59.2155 10.2525 58.5973 10.0807 58.5432 10.1426C58.7013 10.1511 59.1299 10.2778 58.8846 10.284C58.853 10.2846 58.715 10.2031 58.6773 10.2041C58.3251 10.214 59.3083 10.4231 59.4627 10.4548C58.8226 10.4122 57.8999 10.0745 57.173 9.93791C56.9044 9.79919 57.6298 9.9629 57.3199 9.82456C56.6819 9.53542 57.1133 9.85798 57.0899 9.85974C57.0311 9.86426 56.9452 9.81951 56.8543 9.76377C56.6905 9.6537 56.4992 9.49594 56.446 9.66746C56.2558 9.57896 56.3304 9.56238 56.0356 9.5272C56.068 9.55361 56.1003 9.58007 56.1326 9.60656C55.7767 9.67594 55.2096 9.16443 55.2642 9.14532C55.4194 9.09437 55.7398 9.29097 55.77 9.29512C55.8144 9.30097 56.0128 9.06798 56.4322 9.42067C56.6851 9.29882 55.692 9.11373 56.1705 9.10484C55.8654 9.0409 54.6559 8.66971 54.4622 8.73003C54.439 8.73737 54.5014 8.93163 54.2168 8.79442C54.0812 8.72923 54.4285 8.77879 54.3707 8.728C54.2759 8.64319 53.4307 8.50315 52.6025 8.47056C51.8803 8.43589 51.1789 8.48454 50.9469 8.50351C50.9144 8.50569 50.9244 8.44547 50.8923 8.44802C50.7928 8.45471 50.4428 8.57262 50.2692 8.56596C50.634 8.63721 49.9449 8.72117 49.7736 8.74095C49.5104 8.76443 49.5109 8.65842 49.394 8.65651C49.1484 8.65356 48.8519 8.77261 48.5803 8.86607C48.2909 8.95883 48.0148 9.02395 47.8002 8.96697C47.8786 9.19152 47.055 9.0386 46.7172 9.12172C46.4527 9.18713 46.1066 9.43795 46.4856 9.44069C46.0273 9.54619 45.5578 9.71107 45.1333 9.833C45.0632 9.85318 45.1439 9.75978 45.0247 9.79636C45.014 9.80018 45.0152 9.87153 44.9133 9.90461C44.072 10.1783 44.4535 9.92991 44.2832 9.92773C44.1879 9.92641 44.1189 9.9311 44.0695 9.9393C44.5652 9.8019 45.1339 9.63091 45.2873 9.59026C45.1201 9.47442 44.1888 9.896 43.8937 9.92653C43.8834 9.92753 43.898 9.8365 43.8878 9.83841C43.8876 9.83847 43.8874 9.83852 43.8871 9.83857C43.7787 9.85893 43.1046 10.0579 43.2686 10.1217C43.3126 10.1387 43.6263 10.0611 43.996 9.95961C43.8998 10.0031 43.9973 10.0768 43.9805 10.0851C43.7762 10.1845 43.2266 10.2251 43.0364 10.259C42.9929 10.2669 43.0103 10.3255 43.0033 10.3273C42.8297 10.3559 42.8587 10.1693 42.7262 10.387C42.3667 10.2518 43.2967 10.2132 43.2011 10.0915C43.1279 9.9988 41.1716 10.5372 41.2175 10.7014C41.2064 10.6853 41.174 10.6697 41.1123 10.6581C41.0479 10.6458 40.8932 10.6726 40.7383 10.71C40.5642 10.7519 40.3899 10.8069 40.3437 10.8351C40.3291 10.845 40.3745 11.0051 40.3551 11.0113C40.3064 11.0271 39.6044 11.0592 39.3763 11.2124C39.5174 11.2036 39.6583 11.1946 39.7993 11.1855C38.9812 11.3778 39.1191 11.3952 39.4036 11.3808C39.4174 11.3781 39.4321 11.3811 39.4453 11.3788C39.6654 11.3655 39.9445 11.3364 39.9517 11.3482C39.9793 11.3947 38.5962 11.7406 38.8273 11.5297C38.8598 11.5011 39.5188 11.4199 39.1747 11.3864C39.1145 11.3807 38.7088 11.5054 38.6842 11.4984C38.5203 11.4539 39.397 11.1433 39.2598 11.0571C39.0667 11.2137 38.7724 11.2225 38.5278 11.3068C38.4165 11.3451 38.4079 11.4319 38.3942 11.4367C38.1885 11.5052 38.2864 11.3941 38.2165 11.4121C38.1792 11.4223 37.8069 11.6943 37.8258 11.4297C36.4997 11.9139 37.4911 11.6967 38.3274 11.4941C38.0839 11.6442 37.5529 11.7159 37.3241 11.7878C37.2421 11.8136 37.3116 11.8849 37.1739 11.9321C36.9633 12.0045 36.1275 12.1358 35.56 12.2188C35.1829 12.2916 34.8626 12.3145 34.675 12.3229C35.1144 12.2508 34.9707 12.1772 34.6366 12.2123C34.301 12.2382 34.5915 12.3422 34.5268 12.3587C34.4523 12.4272 32.8356 12.2306 32.5891 12.1142C33.1804 12.252 33.4213 12.2258 33.3788 12.1959C33.338 12.159 33.0207 12.0998 32.5404 11.9533C32.6861 11.97 32.8323 11.9812 32.9775 11.9866C32.3783 11.9284 31.3323 11.2846 31.0605 11.1172C31.0135 11.0943 31.1308 11.2582 31.1049 11.2454C30.8236 11.1337 30.1211 10.428 30.0864 10.4019C30.0416 10.3903 30.3072 10.7287 30.1728 10.6427C30.1428 10.6241 29.9124 10.2719 29.6471 9.9732C29.5479 9.8616 29.5502 9.97539 29.5238 9.94808C29.3106 9.71159 29.4986 9.80203 29.1793 9.32621C28.9591 8.97191 28.7094 8.73178 28.5595 8.1552C29.1783 10.0131 28.5087 8.50973 28.3084 7.70185C28.2825 7.57438 28.1474 7.71308 28.119 6.91502C28.5206 8.32193 28.1918 6.92215 28.2214 6.25367C28.2217 6.24573 28.2221 6.23954 28.2237 6.23544C28.225 6.23374 28.3046 6.22991 28.3098 6.2118C28.31 6.21047 28.2563 6.21628 28.2558 6.20302C28.2433 6.08551 28.2852 6.15195 28.3391 6.112C28.3613 6.09156 28.2879 6.04729 28.2827 6.03156C28.2816 6.02729 28.3296 6.00269 28.3227 5.98491C28.3098 5.9529 28.2528 5.95885 28.2411 5.94224C28.2397 5.9403 28.3042 5.88334 28.2595 5.86029C28.2468 5.85392 28.2197 5.8643 28.2126 5.8974C28.184 5.99858 28.3229 6.01471 28.2499 6.10193C28.1795 6.16807 28.1788 6.05132 28.1696 6.04172C28.1683 6.03872 28.2098 6.04221 28.2086 6.00806C28.2034 5.97488 28.0845 6.03457 28.0904 5.98116C28.0927 5.97795 28.1439 5.85051 28.147 5.84505C28.1509 5.84116 28.2025 5.86817 28.2199 5.83406C28.2221 5.82985 28.1963 5.79803 28.2069 5.77218C28.2227 5.74186 28.3754 5.46211 28.3657 5.44508C28.3465 5.40535 28.3294 5.48178 28.3139 5.4634C28.2875 5.42217 28.1551 5.25119 28.1199 5.35498C28.1437 5.37227 28.1664 5.39057 28.1881 5.40983C28.0492 5.35156 28.096 5.42718 28.0725 5.43692C28.048 5.44988 28.0754 5.3602 28.0274 5.33518C28.0188 5.3235 27.8017 5.3056 27.8086 5.34989C27.9251 5.29969 27.8816 5.41126 27.8872 5.41312C27.9052 5.42384 27.9317 5.36471 27.9581 5.3725C28.1316 5.43671 27.9425 5.48154 27.9802 5.52061C27.9903 5.53339 28.0237 5.48856 28.0289 5.49364C28.0442 5.5097 28.0282 5.58052 28.0394 5.57963C28.0664 5.57817 28.0634 5.46484 28.0656 5.46047C28.1099 5.40816 28.1761 5.53664 28.0858 5.61145C28.0996 5.66685 28.1529 5.54202 28.1559 5.60902C28.1532 5.74008 28.1032 5.66661 28.0805 5.67351C28.0022 5.69792 28.0024 5.63572 27.9048 5.62228C27.869 5.61827 27.8319 5.67552 27.8169 5.67681C27.8126 5.6766 27.7455 5.57597 27.7129 5.61424C27.64 5.64808 27.5947 5.71097 27.6193 5.82495C27.4206 5.83099 27.0655 5.67352 26.8727 5.72521C26.6996 5.77141 26.7858 5.87643 26.7706 5.88441C26.7474 5.89673 26.5326 5.9319 26.465 5.96333C26.3859 6.00028 26.4395 6.03581 26.3106 6.08153C25.9897 6.19497 25.9678 6.07579 25.9317 6.07536C25.5124 6.0709 25.7293 6.20055 25.6447 6.23219C25.5659 6.26076 24.4021 6.43945 24.1715 6.53237C24.2638 6.48879 24.3561 6.44512 24.4484 6.40136C24.2542 6.36799 24.098 6.52333 24.0617 6.39745C24.0793 6.60933 23.681 6.55052 23.5736 6.57964C23.5312 6.59107 23.5436 6.6248 23.4902 6.63787C23.2819 6.68898 22.8019 6.76472 22.6927 6.80694C22.2198 6.98752 23.5106 6.839 23.6121 6.82711C23.4129 6.8666 22.3018 7.15145 22.8429 7.137C22.9265 7.13492 23.0447 7.0155 23.0886 7.00241C23.3859 6.91491 23.1683 7.04604 23.1941 7.04861C23.2377 7.05248 23.4172 6.93239 23.4723 6.93054C23.4907 6.92988 23.3964 7.0267 23.6864 6.96781C23.5624 7.06829 22.7337 7.18141 22.6314 7.22109C22.595 7.23529 22.8719 7.33301 22.1384 7.33701C22.1501 7.34904 22.1617 7.36107 22.1734 7.37311C21.7875 7.4616 21.4018 7.55105 21.0164 7.64163C21.0503 7.60129 21.2512 7.4907 20.9811 7.56435C20.8257 7.60686 20.9602 7.65038 20.9464 7.65559C20.8595 7.68734 19.81 7.9137 18.9381 8.11461C18.4416 8.22851 18.0017 8.3308 17.8272 8.37479C17.6636 8.41592 17.2197 8.57766 17.1851 8.5869C16.9777 8.6414 16.2298 8.78241 16.0845 8.82523C15.9937 8.85199 16.0955 8.88622 16.0127 8.90323C15.9356 8.91897 16.0009 8.84687 15.9776 8.85006C15.7846 8.87547 14.3752 9.28753 14.0235 9.32027C14.2345 9.28501 15.2406 8.93055 15.2101 8.89817C15.2043 8.8941 14.9426 8.91456 14.8959 8.9467C14.7984 8.92175 14.5407 9.13179 14.3738 9.14316C14.3549 9.14447 14.4058 9.04936 14.117 9.10457C14.0175 9.12369 13.7759 9.24653 13.4995 9.24206C13.1329 9.36507 11.1376 9.74945 11.024 9.86504C11.0211 9.87032 11.3057 9.83031 11.1271 9.90996C10.8897 10.0158 11.0742 9.81047 10.7806 9.86909C10.7363 9.87788 9.93282 10.0924 9.9088 10.1082C9.68606 10.2524 10.4005 10.1124 10.3932 10.1247C10.375 10.1553 9.79252 10.3145 9.76719 10.3146C9.74296 10.3142 10.1922 10.0852 9.62858 10.2691C9.69785 10.2661 9.76712 10.2631 9.8364 10.2601C9.57289 10.3525 9.52717 10.2822 9.46049 10.2937C9.25317 10.3292 9.06323 10.4996 8.69991 10.4369C8.60382 10.4203 8.73592 10.3426 8.72364 10.3396C8.60679 10.3141 8.5103 10.4836 8.32807 10.4203C8.31438 10.4156 8.66074 10.2645 8.02752 10.4218C8.07364 10.4207 8.11976 10.4196 8.16588 10.4185C8.08227 10.4625 7.4445 10.6346 7.35691 10.6509C7.10104 10.6985 7.30261 10.5742 7.05155 10.6456C7.23886 10.7007 6.47194 10.9043 6.4949 10.8114C6.41414 10.941 5.73926 11.0241 5.43111 11.0982C5.2367 11.145 4.85247 11.2877 4.78945 11.2978C4.71268 11.31 4.71739 11.2349 4.57775 11.2531C4.53794 11.2584 4.14743 11.4093 3.77438 11.4257C3.7021 11.4289 3.52735 11.3476 3.64735 11.2865C3.85272 11.1819 4.2906 11.1734 4.26723 11.1053C4.24166 11.0325 3.69665 11.2157 3.54431 11.2434C2.84107 11.3713 3.21999 11.1931 3.19598 11.1737C3.1348 11.1274 2.75748 11.2239 2.74036 11.2227C2.66904 11.2161 2.92485 11.1033 2.9197 11.067C2.91261 11.0198 2.52702 11.0288 2.60577 10.9925C2.71851 10.9407 3.07102 10.9254 3.09139 10.9167C3.35587 10.8025 2.94977 10.7918 2.83195 10.7663C2.79617 10.7583 2.91526 10.7 2.88782 10.7019C2.46921 10.7321 2.84228 10.8722 2.57231 10.9248C2.33145 10.9717 2.61886 10.825 2.60878 10.8234C2.59596 10.8222 2.31109 10.8902 2.26026 10.8769C2.2352 10.8703 2.93767 10.5478 2.89098 10.4946C2.65915 10.568 2.42729 10.6413 2.19541 10.7145C2.15641 10.6403 2.51003 10.6122 2.54293 10.5951C2.60914 10.5608 2.40219 10.5709 2.40412 10.5437C2.40452 10.5267 2.62034 10.411 2.40592 10.4409C2.33222 10.4512 2.19637 10.5449 1.92088 10.5551C2.80956 10.2507 2.16909 10.3671 2.1351 10.3461C2.10163 10.3249 2.51757 10.1477 1.99491 10.2945C1.93213 10.1469 1.9936 10.2431 2.13593 10.1776C2.31025 10.0972 1.87421 10.1557 2.55289 10.0216C2.49606 9.95923 1.95999 10.1033 1.93004 10.1049C1.90412 10.1061 2.01436 10.0398 1.96865 10.0389C1.42876 10.0306 1.79126 10.0043 1.62231 9.95362C1.60727 9.94905 1.12276 10.0401 1.48176 9.93295C2.13577 9.73752 2.43832 9.768 2.4923 9.52047C1.97944 9.55327 1.42461 9.84857 1.27676 9.88948C1.05049 9.95218 1.27429 9.84654 1.24307 9.84144C1.2323 9.83997 1.03752 9.89478 1.03397 9.89196C0.851367 9.76322 1.90456 9.66124 2.21537 9.54936C2.12357 9.54674 2.03178 9.54417 1.93999 9.54163C2.05546 9.51031 2.17092 9.47899 2.28639 9.44767C1.72203 9.54204 2.26204 9.43392 2.36432 9.2628C2.38727 9.22435 2.03873 9.37166 2.42982 9.17866C2.12012 9.23943 2.21013 9.18635 1.94419 9.297C1.93727 9.24123 2.54191 9.01644 2.77938 8.92388C1.89899 9.09167 2.44365 9.15954 1.66892 9.25222C1.54768 9.35553 1.90108 9.24837 1.87486 9.26707C1.78078 9.33418 1.51975 9.33608 1.26053 9.55221C1.21835 9.58755 1.44004 9.60403 1.13806 9.6797C1.10463 9.68795 0.897245 9.67873 0.898784 9.67373C0.912058 9.62037 1.10644 9.58788 1.10919 9.56631C1.11174 9.54591 0.902858 9.6128 0.900795 9.60788C0.879055 9.55111 1.07166 9.53894 1.04028 9.52764C0.972395 9.50277 0.178139 9.57862 1.18159 9.35243C0.373291 9.63695 1.09274 9.44504 1.40761 9.33466C1.48794 9.3066 1.49957 9.26605 1.61321 9.22296C1.75936 9.16741 1.93963 9.13775 2.01571 9.11073C2.09747 9.08145 1.60069 9.12415 2.29431 8.96693C1.92303 8.97681 1.32831 9.22874 0.969761 9.26209C0.246509 9.32987 1.41594 8.99177 1.53546 8.9477C1.56729 8.93592 1.44553 8.9177 1.46653 8.909C1.50093 8.89501 2.17399 8.73907 2.22954 8.68213C2.2849 8.62527 1.98558 8.74914 1.9543 8.71365C1.93316 8.68986 2.72528 8.42561 2.28464 8.52321C1.98099 8.59072 1.45626 8.84941 1.33209 8.75558C1.77111 8.62739 2.21013 8.49923 2.64917 8.37108C2.39559 8.39024 2.14207 8.40962 1.88861 8.42923C2.38037 8.28152 2.82222 8.21805 3.27586 8.02627C2.10684 8.18405 3.61257 7.81051 3.62438 7.78816C3.62709 7.77591 3.15103 7.77687 3.07379 7.77458C3.4562 7.62234 4.64837 7.27551 3.90903 7.31777C4.04492 7.3166 4.33152 7.1507 4.32582 7.14555C4.26969 7.09083 3.60896 7.31581 3.7032 7.22721C3.81237 7.12437 4.01439 7.16857 4.2078 7.10808C5.20004 6.797 4.83585 6.52927 5.85455 6.30856C5.83137 6.30178 5.8082 6.295 5.78503 6.28823C6.88198 6.00869 7.97901 5.72944 9.07585 5.4495C9.47518 5.22555 10.5943 4.84593 11.1553 4.70286C11.2683 4.67401 11.8347 4.57779 11.8789 4.57626C11.961 4.57406 11.539 4.69897 11.7399 4.68177C11.7823 4.67801 12.7224 4.44281 12.6396 4.40009C12.5332 4.42217 12.2137 4.54393 12.1564 4.54442C11.7535 4.5475 14.6523 3.8254 14.7835 3.74177C14.7145 3.73956 14.6456 3.73738 14.5766 3.73521C14.7607 3.69386 14.9447 3.65247 15.1287 3.61104ZM8.01765 10.6743C7.92326 10.7607 7.63639 10.7843 7.47806 10.8411C7.25943 10.92 6.9365 11.2412 7.04172 10.9731C7.36705 10.8736 7.69236 10.774 8.01765 10.6743ZM12.8657 9.57799C12.6357 9.59924 12.7733 9.42603 12.969 9.43629C12.9908 9.43756 13.1769 9.54916 12.8657 9.57799ZM10.5283 10.0845C10.5372 10.0805 10.7294 10.0368 10.7366 10.0372C10.9217 10.0472 10.3422 10.1782 10.5283 10.0845ZM21.7447 7.3498C21.5007 7.40948 21.7124 7.5006 21.8512 7.41418C21.8599 7.40868 21.7607 7.34595 21.7447 7.3498ZM21.5691 7.38446C21.3482 7.31032 21.0254 7.62933 21.3245 7.53873C21.3535 7.52992 21.5794 7.38823 21.5691 7.38446ZM12.0628 9.7186C12.0771 9.67171 12.3106 9.63549 12.4107 9.62144C12.4178 9.6594 12.1572 9.69061 12.0628 9.7186ZM17.8562 8.3107C17.8572 8.27474 17.0623 8.46531 17.0196 8.52208C17.1402 8.47349 17.8549 8.34282 17.8562 8.3107ZM19.8856 7.7873C19.8638 7.78593 19.5908 7.85795 19.6067 7.88621C19.7514 7.89484 19.9836 7.79339 19.8856 7.7873ZM23.9605 6.9059C23.9734 6.89472 23.7128 6.73297 24.239 6.76549C24.3163 6.7704 24.0727 6.87756 24.1002 6.87957C24.1577 6.88283 24.2018 6.8808 24.2362 6.87497C24.0118 6.93918 23.7763 6.99635 23.7501 6.98877C23.6269 6.95281 23.9547 6.91059 23.9605 6.9059ZM26.0648 6.30888C26.1029 6.26439 26.409 6.22136 26.4813 6.22193C26.4938 6.22227 26.4665 6.32488 26.6004 6.29063C26.7079 6.26292 26.5205 6.20112 26.7366 6.17319C26.955 6.145 26.6861 6.27077 26.7061 6.27172C26.7329 6.27304 27.0536 6.16342 27.0577 6.22108C27.0607 6.26375 26.6979 6.3071 26.6122 6.3335C26.5026 6.36722 26.6568 6.40779 26.4648 6.43078C26.3441 6.44531 26.3787 6.31327 26.3522 6.31228C26.33 6.31172 25.9347 6.46362 26.0656 6.30912C26.0653 6.30904 26.0651 6.30896 26.0648 6.30888ZM24.2968 6.85718C24.2806 6.86458 24.2609 6.8708 24.2362 6.87497C24.2566 6.86914 24.2768 6.86309 24.2968 6.85718ZM8.64584 10.4733C8.76873 10.4751 8.43737 10.5981 8.29779 10.5906C8.28726 10.5593 8.6263 10.4731 8.64584 10.4733ZM24.4847 6.72018C24.8321 6.67868 24.5924 6.77001 24.2968 6.85718C24.3871 6.81594 24.3681 6.73426 24.4847 6.72018ZM14.8959 8.9467C14.9121 8.95085 14.9242 8.9605 14.9304 8.97966C14.8875 8.96743 14.8812 8.95683 14.8959 8.9467ZM15.6911 8.79196C15.9452 8.66756 15.3982 8.8018 15.4127 8.84352C15.4185 8.85916 15.681 8.79691 15.6911 8.79196ZM22.0614 7.2877C22.035 7.28695 22.3699 7.01009 21.8483 7.27654C22.1527 7.23432 21.8432 7.32374 21.8523 7.33954C21.877 7.3852 22.3666 7.23048 22.4832 7.22794C22.5474 7.1218 22.1486 7.29063 22.062 7.28757C22.0618 7.28761 22.0616 7.28766 22.0614 7.2877ZM27.9289 6.13543C27.9017 6.18586 27.9106 6.15391 27.909 6.14049C27.9281 6.087 27.929 6.12163 27.9289 6.13543ZM63.3392 11.171C62.2591 11.078 62.1704 10.8217 63.1254 11.0538C63.1437 11.0586 63.4089 11.1567 63.3392 11.171ZM54.7343 9.30187C54.6779 9.17272 54.9525 9.2009 55.119 9.28261C55.1569 9.30099 55.2765 9.4445 55.1023 9.4346C55.1416 9.29781 54.8902 9.19463 54.7343 9.30187ZM24.661 6.6198C24.7435 6.53601 25.0597 6.51766 25.2228 6.49427C25.1385 6.56701 24.808 6.60998 24.661 6.6198ZM59.8706 10.4515C59.7614 10.4199 59.6625 10.4951 59.6795 10.5068C59.7556 10.5599 59.9842 10.5301 59.8706 10.4515ZM23.6758 6.81591C23.6523 6.78187 24.0459 6.66058 24.098 6.74712C24.0101 6.75846 23.6918 6.83701 23.6758 6.81591ZM27.9349 6.08516C27.9392 6.05936 27.9687 6.04892 27.9629 6.07724C27.941 6.11731 27.9317 6.1015 27.9349 6.08516ZM58.0732 10.0672C57.9781 10.0347 57.7301 9.96756 57.6905 9.99779C57.6418 10.0363 58.0119 10.1146 58.0732 10.0672ZM76.7493 10.8302C76.7626 10.838 76.3847 10.9738 76.2139 10.9814C75.8895 10.9953 76.7346 10.8269 76.7493 10.8302ZM60.9385 10.616C61.2323 10.7598 60.9031 10.6122 60.8952 10.7047C61.1043 10.7478 61.639 10.8467 61.2923 10.6935C61.2248 10.6636 61.0352 10.6403 60.9385 10.616ZM60.6555 10.5301C60.6142 10.5527 60.3632 10.6003 60.5619 10.6323C60.6541 10.6469 60.8272 10.5732 60.6555 10.5301ZM74.3725 11.1831C74.0887 11.1614 75.3822 11.0408 75.4166 11.04C75.4363 11.0423 75.4493 11.0451 75.4567 11.048C75.503 11.0252 75.7457 10.9888 75.7762 11.0257C75.703 11.0329 75.5043 11.0643 75.4811 11.0627C75.471 11.0621 75.4635 11.0612 75.4583 11.0601C75.3769 11.1108 74.4248 11.1907 74.3725 11.1831ZM72.2229 11.3053C72.5488 11.1978 72.6054 11.3424 72.5772 11.3491C72.2211 11.4343 72.4543 11.3082 72.4434 11.3039C72.4187 11.297 72.1664 11.3639 72.2239 11.3052C72.2235 11.3052 72.2232 11.3052 72.2229 11.3053ZM73.9317 11.2061C73.9448 11.2032 74.2168 11.1797 74.2282 11.1805C74.4523 11.204 73.6821 11.2718 73.9317 11.2061ZM27.6472 5.84441C27.8357 5.8263 27.6744 5.93468 27.5457 5.93368C27.535 5.93317 27.4809 5.86049 27.6472 5.84441ZM60.4949 10.5193C60.4535 10.5006 59.3221 10.202 59.3579 10.3271C59.4616 10.3417 60.7503 10.6663 60.4949 10.5193ZM52.8275 8.90504C52.9902 8.91685 52.7999 9.02654 52.7185 8.97648C52.6881 8.95773 52.7864 8.90212 52.8275 8.90504ZM23.1105 6.84648C22.9251 6.94039 22.9215 6.75993 23.109 6.78153C23.1164 6.78238 23.1178 6.84281 23.1105 6.84648ZM54.128 9.10852C53.5484 9.10869 53.742 8.73736 54.4696 8.9782C54.4428 8.99106 54.4161 9.004 54.3894 9.01701C55.2407 9.21563 54.4422 9.04872 54.2284 9.04152C54.1471 9.03798 54.2022 9.11013 54.1285 9.10905C54.1283 9.10887 54.1282 9.1087 54.128 9.10852ZM51.9783 8.86632C51.5404 8.63235 52.1795 8.71745 52.5781 8.75431C52.6555 8.76083 52.7236 8.76465 52.7728 8.76183C52.7061 8.78301 52.6363 8.79804 52.5733 8.81028C52.3603 8.85236 52.2262 8.85869 52.5609 8.95465C52.5734 8.95831 52.5866 8.96211 52.6004 8.96607C52.5866 8.96581 52.5731 8.96555 52.56 8.96527C51.8768 8.95804 52.177 8.8647 52.1486 8.85338C52.1144 8.84223 52.0004 8.87835 51.9783 8.86632ZM53.4015 8.94258C53.4342 8.93746 53.664 9.01769 53.751 9.01935C53.6164 9.09557 53.1855 8.97621 53.4015 8.94258ZM69.9573 11.4263C69.9847 11.3744 70.0506 11.3368 70.281 11.3525C70.2081 11.3793 70.0571 11.4034 69.9573 11.4263ZM7.74205 10.4682C7.5919 10.5018 7.28998 10.5573 7.39448 10.586C7.40559 10.5879 7.74912 10.4972 7.74205 10.4682ZM57.1888 9.67644C57.1772 9.66992 57.049 9.63129 56.9106 9.59362C56.7115 9.54119 56.4806 9.49778 56.623 9.58487C56.6497 9.60122 56.7663 9.63626 56.8865 9.66642C57.1075 9.72441 57.3457 9.76758 57.1888 9.67644ZM61.7086 10.6994C61.6349 10.6863 61.3361 10.6456 61.3246 10.6587C61.2938 10.707 61.6651 10.7428 61.7086 10.6994ZM6.97625 10.6056C6.95528 10.6054 6.50186 10.7279 6.5581 10.7391C6.66484 10.76 7.04815 10.6063 6.97625 10.6056ZM27.843 5.68479C27.8505 5.68378 27.8631 5.75588 27.865 5.75732C27.8723 5.75692 27.9719 5.77623 27.9257 5.84855C27.9235 5.85705 27.8228 5.78521 27.7558 5.77876C27.7219 5.78421 27.6963 5.78817 27.6815 5.79022C27.6575 5.76423 27.688 5.74635 27.7438 5.73301C27.7702 5.72832 27.8182 5.77253 27.8283 5.76881C27.831 5.76764 27.8238 5.68826 27.843 5.68518C27.843 5.68505 27.843 5.68492 27.843 5.68479ZM71.1775 11.3454C71.2118 11.2989 72.0954 11.2304 72.0827 11.2839C71.7838 11.3072 71.4782 11.3277 71.1775 11.3454ZM70.7291 11.3511C70.5411 11.3219 70.9867 11.3005 71.1136 11.3103C71.1144 11.3422 70.7567 11.3557 70.7291 11.3511ZM60.1054 10.1559C60.0132 10.1519 60.262 10.2978 60.1969 10.302C60.1547 10.3045 59.9662 10.2295 59.8968 10.2437C59.8765 10.2487 60.055 10.3746 60.1148 10.3831C60.1991 10.3957 60.136 10.3138 60.2259 10.3321C60.5191 10.3914 60.7793 10.4915 61.0555 10.542C61.0807 10.5466 60.8964 10.4642 61.1111 10.5054C61.143 10.5114 61.3325 10.6178 61.5901 10.6523C62.2084 10.5448 62.582 10.8167 63.3238 10.8446C63.2983 10.8224 62.7685 10.6919 62.7374 10.6843C62.1375 10.5601 61.0598 10.3623 60.4301 10.2288C60.2698 10.1954 60.3362 10.2564 60.2669 10.2437C60.2121 10.2335 60.299 10.1643 60.1054 10.1559ZM7.81209 10.4131C7.72432 10.3669 7.48539 10.4695 7.32519 10.5059C7.39626 10.5495 7.65269 10.4377 7.81209 10.4131ZM66.7623 11.2204C66.6753 11.218 66.412 11.1774 66.3873 11.1981C66.3547 11.2256 66.7373 11.2696 66.7623 11.2204ZM28.1971 6.13626C28.1995 6.13636 28.1911 6.15868 28.188 6.16005C28.1132 6.19572 28.1426 6.13972 28.1971 6.13626ZM31.7177 11.904C31.992 12.0155 32.2824 12.0815 32.3556 12.1878C32.1751 12.1251 31.6625 11.9442 31.7177 11.904ZM40.014 11.3066C39.9582 11.2075 40.4146 11.1723 40.4999 11.1618C40.4806 11.2166 40.0547 11.3781 40.014 11.3066ZM69.9373 11.2021C70.227 11.2052 70.1713 11.0979 70.3506 11.145C70.3799 11.1528 70.4637 11.3743 70.1529 11.2948C70.0966 11.2799 70.3237 11.2259 69.9373 11.2021ZM54.591 9.00112C54.6646 8.94617 54.8492 8.99799 54.9754 9.027C54.9358 9.06888 54.6823 9.01097 54.591 9.00112ZM6.13984 10.7598C5.99773 10.7283 5.42893 10.9199 5.58347 10.9254C5.60532 10.9257 6.05773 10.7777 6.13984 10.7598ZM25.286 6.23226C25.5117 6.12136 25.0072 6.20898 24.8646 6.30052C24.935 6.28149 25.2707 6.23956 25.286 6.23226ZM38.4703 11.6008C38.4811 11.5951 38.7377 11.545 38.75 11.5462C38.9785 11.5804 38.2524 11.7223 38.4703 11.6008ZM29.4608 9.9559C29.5949 10.0794 30.3752 10.9483 30.5761 11.1393C30.2744 11.0998 29.232 9.84263 29.4608 9.9559ZM68.7481 11.2213C68.9534 11.2236 69.148 11.2405 69.3372 11.2614C69.2936 11.2989 68.7665 11.251 68.7481 11.2213ZM39.4036 11.3808C39.4174 11.3781 39.4321 11.3811 39.4453 11.3788C39.4312 11.3796 39.4172 11.3801 39.4036 11.3808ZM64.1486 10.8568C63.9787 10.8186 64.0005 10.9005 64.0108 10.9042C64.1383 10.9459 64.3379 10.899 64.1486 10.8568ZM7.60445 10.3647C7.53401 10.3214 7.27599 10.433 7.11739 10.4581C7.17411 10.4919 7.48111 10.4018 7.60445 10.3647ZM51.4127 8.6929C51.2399 8.60035 51.9439 8.47772 52.0928 8.54656C52.0983 8.60129 51.4354 8.7013 51.4127 8.6929ZM24.5105 6.28974C24.4805 6.24037 24.1502 6.37886 24.2303 6.38775C24.2811 6.39352 24.5287 6.32054 24.5105 6.28974ZM52.4473 8.59734C52.4857 8.58732 52.5501 8.60636 52.5886 8.63183C52.6188 8.65175 52.6333 8.67545 52.6077 8.692C52.5996 8.69724 52.5912 8.70029 52.5827 8.70157C52.5125 8.7121 52.4316 8.60199 52.4473 8.59734ZM58.8761 9.81861C58.8423 9.80113 58.3508 9.74381 58.5293 9.85361C58.6522 9.92933 58.6994 9.84874 58.7314 9.85639C58.7658 9.86622 59.5089 10.1554 58.8761 9.81861ZM47.4626 9.32385C47.6267 9.25337 47.8402 9.23091 48.018 9.18276C47.9557 9.24419 47.5489 9.36193 47.4626 9.32385ZM25.8452 5.98983C25.7975 5.97644 24.6543 6.20686 25.3193 6.13546C25.358 6.13102 25.9897 6.02942 25.8452 5.98983ZM69.9373 11.2021C69.9008 11.2016 69.8589 11.1994 69.8105 11.1947C69.8588 11.1966 69.9007 11.1998 69.9373 11.2021ZM66.6621 11.0847C66.733 11.0519 66.4009 11.0178 66.3008 11.0301C66.264 11.0746 66.6519 11.0896 66.6621 11.0847ZM48.0147 9.10936C48.1105 9.05411 48.3044 9.03635 48.4308 8.99994C48.4205 9.05201 48.0706 9.14523 48.0147 9.10936ZM40.7715 10.8645C40.7728 10.8643 40.7742 10.8642 40.7755 10.8641C40.9863 10.8423 41.232 10.7688 41.2219 10.7101C41.2284 10.7181 41.2406 10.7254 41.2595 10.7311C41.2784 10.7366 41.4913 10.6563 41.5914 10.6529C41.9236 10.6413 41.215 10.829 40.7849 10.9027C40.4812 10.9546 40.3165 10.9506 40.7557 10.7821C40.8162 10.7588 40.8882 10.7324 40.9727 10.7026C40.9068 10.7556 40.8409 10.8087 40.775 10.8617C40.7738 10.8626 40.7727 10.8635 40.7715 10.8645ZM28.7955 8.51986C28.7652 8.29204 28.5202 7.72042 28.539 7.88186C28.5364 8.00103 28.8119 8.75789 28.7955 8.51986ZM35.7173 11.9452C35.6968 11.9426 35.5971 11.9754 35.51 12.012C35.3683 12.0596 35.2405 12.1015 35.2365 12.1196C35.3223 12.1142 35.4246 12.0983 35.5253 12.0753C35.6927 12.0394 35.8487 11.9629 35.7173 11.9452ZM28.4839 6.85756C28.4821 6.72303 28.3712 6.55457 28.3673 6.57095C28.3295 6.71545 28.4456 7.09267 28.4839 6.85756ZM69.357 10.989C69.2415 10.9649 68.8666 11.0127 68.7818 11.063C68.7677 11.0524 68.7285 11.0381 68.6563 11.0199C68.6565 11.0199 68.6567 11.02 68.6569 11.02C68.5561 11.0143 65.5689 10.8037 67.5638 11.0322C67.6267 11.0388 67.5453 10.9859 67.8022 11.0075C67.8193 11.009 67.8231 11.0489 67.8749 11.0532C67.9918 11.0639 68.6362 11.1118 68.7645 11.0827C68.765 11.0899 68.7727 11.0969 68.7898 11.1036C68.9423 11.1631 69.4466 11.0076 69.357 10.989ZM36.3492 11.7995C36.28 11.7933 36.0808 11.8562 36.0712 11.9083C36.178 11.9101 36.5099 11.8141 36.3492 11.7995ZM25.7696 5.8429C25.6303 5.84029 25.3128 5.9697 25.4213 5.97851C25.4878 5.98409 25.9302 5.846 25.7696 5.8429ZM33.2146 12.0654C34.6623 12.2863 33.5601 12.1057 33.7866 12.0601C33.5967 12.0714 33.4063 12.0733 33.2146 12.0654ZM73.0451 11.0146C72.9183 11.0131 73.0673 10.9187 73.2073 10.9549C73.2513 10.9662 73.1162 11.0151 73.0451 11.0146ZM78.7175 10.2374C78.6057 10.203 79.1234 10.1322 78.9277 10.2103C78.9185 10.2136 78.7252 10.2382 78.7175 10.2374ZM74.7663 10.8105C74.6823 10.8668 74.6263 10.8791 74.3853 10.8911C74.7414 10.8417 74.4092 10.8331 74.7663 10.8105ZM41.2175 10.7014C41.2196 10.7046 41.2214 10.7068 41.2219 10.7101C41.2197 10.7073 41.2183 10.7045 41.2175 10.7014ZM28.4586 6.17493C28.527 6.14758 28.5219 6.08959 28.4571 6.1209C28.4516 6.12451 28.4114 6.17319 28.4586 6.17493ZM68.7818 11.063C68.7943 11.0723 68.787 11.078 68.7645 11.0827C68.7641 11.076 68.7703 11.0698 68.7818 11.063ZM28.7781 8.14261C28.7136 8.14467 28.9768 8.85931 29.0071 8.87929C29.2783 9.22595 28.8596 8.44381 28.7781 8.14261ZM23.1006 6.36712C23.081 6.37579 23.241 6.44827 23.3124 6.39017C23.3676 6.34498 23.174 6.33407 23.1006 6.36712ZM75.5834 10.6984C75.7167 10.6821 75.905 10.6579 75.9419 10.6879C75.8517 10.6947 75.5819 10.7249 75.5834 10.6984ZM78.5101 10.2364C78.358 10.3016 78.0022 10.3685 77.7756 10.4019C77.7664 10.3552 78.3644 10.2768 78.5101 10.2364ZM69.7202 11.0196C69.709 11.017 69.3733 10.9919 69.416 11.0392C69.4779 11.1088 69.8141 11.0454 69.7202 11.0196ZM23.7334 6.28444C23.8667 6.2179 23.511 6.18339 23.3822 6.29952C23.316 6.35876 23.7109 6.2955 23.7334 6.28444ZM28.5343 5.98135C28.495 5.9571 28.4502 6.07285 28.5109 6.06674C28.5154 6.04797 28.5495 5.9919 28.5343 5.98135ZM34.883 11.9101C33.7713 11.7862 34.3827 12.1136 34.5878 12.0744C34.6176 12.07 34.9127 11.9131 34.883 11.9101ZM4.61251 10.8651C4.53392 10.9039 4.86135 10.8913 4.89034 10.8383C4.90816 10.8052 4.66277 10.8402 4.61251 10.8651ZM44.0695 9.9393C44.0448 9.94614 44.0203 9.95295 43.996 9.95961C44.0135 9.9517 44.0373 9.94462 44.0695 9.9393ZM28.4727 5.41596C28.4155 5.71413 28.5175 5.5493 28.5296 5.56119C28.5449 5.58336 28.5278 5.67634 28.5573 5.70505C28.5095 5.68122 28.4607 5.66205 28.412 5.64765C28.4466 5.69419 28.4742 5.99691 28.4977 5.9787C28.5562 5.96218 28.5156 5.88739 28.5181 5.88267C28.5239 5.87604 28.6612 5.77471 28.6617 5.76118C28.6753 5.7377 28.5028 5.47913 28.4727 5.41596ZM32.578 11.7443C32.7431 11.8159 32.7778 11.8982 32.8635 11.9016C32.8927 11.9023 32.9121 11.8362 33.0099 11.8393C32.865 11.8134 32.7204 11.7816 32.578 11.7443ZM28.1781 5.47605C28.1761 5.38767 28.2971 5.49813 28.2937 5.51072C28.2866 5.56901 28.1788 5.54404 28.1781 5.47605ZM28.7301 7.76777C28.7131 7.73259 28.6082 6.99563 28.5761 7.00638C28.5395 7.20888 28.777 8.19591 28.7301 7.76777ZM33.1279 11.8587C33.3864 11.9246 33.8947 12.0355 33.8407 11.9238C33.8403 11.9238 33.8399 11.9237 33.8396 11.9237C33.6013 11.9172 33.3634 11.8955 33.1279 11.8587ZM24.1774 6.00909C23.8799 5.94145 24.0468 6.07313 24.2919 6.06249C24.348 5.98973 24.2262 6.02008 24.1774 6.00909ZM23.3067 6.10501C23.2273 6.09902 22.4761 6.29609 22.6087 6.33496C22.6559 6.34891 23.0763 6.19141 23.0975 6.19138C23.1297 6.19129 23.0096 6.29534 23.2384 6.22868C23.2183 6.20705 23.3338 6.10685 23.3067 6.10501ZM23.9374 5.97692C23.6497 5.94018 23.6366 6.1299 23.8344 6.08623C23.9117 6.06935 23.9785 5.98239 23.9374 5.97692ZM25.0151 5.75271C24.916 5.75644 24.6576 5.78787 24.4995 5.88615C24.7332 5.83953 24.9671 5.79315 25.2009 5.747C25.2188 5.70686 25.1018 5.74944 25.0145 5.75285C25.0147 5.7528 25.0149 5.75275 25.0151 5.75271ZM80.1001 9.64801C79.8823 9.66614 80.3732 9.55177 80.3953 9.55312C80.4606 9.56102 80.1974 9.63987 80.1001 9.64801ZM2.64236 9.92874C2.58048 9.92691 2.52857 9.88175 2.40944 9.94328C2.54736 9.95082 2.6853 9.95845 2.82326 9.96618C2.89802 9.84758 2.71004 9.93091 2.64236 9.92874ZM2.06778 9.71594C2.08518 9.70901 1.94983 9.59215 2.20692 9.62664C2.38067 9.65012 1.54325 9.93488 1.37276 9.91208C1.5354 9.83845 1.91774 9.77456 2.06778 9.71594ZM0.413438 9.49501C0.400678 9.48637 0.720321 9.3839 0.759889 9.3819C0.967716 9.37167 0.482337 9.54119 0.413438 9.49501ZM1.45402 9.2482C1.29489 9.26086 1.62685 9.15389 1.73131 9.14322C1.74794 9.16714 1.47854 9.246 1.45402 9.2482ZM77.7688 8.49696C77.5946 8.43364 77.4608 8.60196 77.7146 8.55345C77.7267 8.55111 77.7763 8.50005 77.7688 8.49696ZM0.692996 9.26839C0.852052 9.25546 0.520146 9.36262 0.41575 9.37351C0.39959 9.34976 0.668822 9.27052 0.692996 9.26839ZM77.634 8.32887C77.4069 8.28626 77.5017 8.46208 77.5306 8.46758C77.6484 8.48965 78.0323 8.39593 78.1111 8.374C77.5266 8.43682 77.7409 8.34788 77.634 8.32887ZM76.6179 8.4833C76.4124 8.51151 76.944 8.52927 77.0396 8.47233C76.9371 8.47967 76.6773 8.4755 76.6179 8.4833ZM75.3613 8.44686C75.2504 8.44074 74.9212 8.4227 74.8663 8.45504C74.9884 8.44994 75.316 8.48037 75.3613 8.44686ZM75.1072 8.35085C74.9327 8.30576 74.8959 8.43476 75.0942 8.39682C75.1019 8.39534 75.1136 8.35331 75.1072 8.35085ZM74.1346 8.28932C74.0199 8.23258 73.8929 8.36027 74.0771 8.36825C74.1319 8.37024 74.1468 8.29575 74.1346 8.28932ZM77.3373 8.14736C77.173 8.13285 76.9707 8.21902 77.3185 8.21581C77.1975 8.2322 77.0768 8.24838 76.9564 8.26435C77.414 8.29358 77.3717 8.18457 77.5028 8.18464C77.6858 8.18394 77.6795 8.27166 77.646 8.30113C77.788 8.24097 78.4272 8.20678 78.7903 8.17124C78.4675 8.17306 77.936 8.16357 77.6193 8.16065C77.5292 8.15994 77.4418 8.18767 77.3641 8.18772C77.2393 8.18752 77.3465 8.1483 77.3379 8.14734C77.3377 8.14735 77.3375 8.14736 77.3373 8.14736ZM72.8609 8.23836C72.5313 8.15614 72.7385 8.30715 72.9261 8.29118C72.9341 8.2897 72.8691 8.2404 72.8609 8.23836ZM0.146827 8.95814C0.600221 8.89875 0.302098 9.06261 1.1879 8.69773C0.824658 8.8852 1.18234 8.76388 1.116 8.81797C1.06267 8.86095 0.830885 8.89933 0.97631 8.91808C0.788318 8.90556 0.0429598 9.12304 0.00707543 9.12254C0.00738966 9.12246 0.00770393 9.12237 0.00801817 9.12229C-0.0135118 9.12208 0.00217864 8.9772 0.146827 8.95814ZM75.344 8.12518C75.2263 7.97388 75.195 8.21224 74.9717 8.08313C74.6901 8.26219 75.7698 8.09569 75.9128 8.24004C74.7221 8.22837 76.7053 8.3806 75.8642 8.16565C76.5488 8.24089 76.085 8.13761 76.188 8.10946C76.298 8.08005 76.6872 8.10689 76.6638 8.05522C76.6636 8.05523 76.6634 8.05523 76.6631 8.05523C76.4264 8.06188 76.1909 8.06687 75.9568 8.07028C76.1943 8.18533 75.7107 8.15363 75.5415 8.0545C75.4757 8.07794 75.4098 8.1015 75.344 8.12518ZM76.6876 8.22553C76.6635 8.22414 76.1498 8.24874 76.1848 8.2709C76.2537 8.28582 76.985 8.25098 76.6876 8.22553ZM78.9477 8.101C78.7624 8.11371 78.4765 8.11082 78.3799 8.15399C78.5643 8.14416 78.8513 8.14426 78.9477 8.101ZM69.489 7.82113C69.2532 7.84058 69.9664 7.94004 69.7639 7.85973C69.7541 7.85609 69.5012 7.82054 69.489 7.82113ZM74.8119 8.13997C74.5716 8.08769 74.6893 8.24063 74.8654 8.20425C74.8755 8.20216 74.823 8.14237 74.8119 8.13997ZM0.496618 8.84237C0.501778 8.79746 1.1449 8.65481 1.25751 8.6242C1.20338 8.67941 0.490668 8.89378 0.496618 8.84237ZM79.2599 7.974C78.8767 7.89773 78.3979 8.03902 78.3417 8.04033C78.2868 8.0402 78.367 7.98948 78.3545 7.98885C78.3252 7.98843 77.7474 8.01498 77.7205 8.01843C77.7008 8.02186 77.8119 8.08617 77.6952 8.11222C77.9229 8.06803 78.9833 8.03577 79.0378 8.02213C79.0798 8.01386 78.7495 7.96898 79.2592 7.97404C79.2595 7.97403 79.2597 7.97401 79.2599 7.974ZM78.203 8.03242C78.351 8.05344 77.945 8.07586 77.8465 8.06871C77.6266 8.05358 78.1835 8.03075 78.203 8.03242ZM77.2266 8.03928C77.1793 8.03432 76.7631 8.0352 76.7309 8.06924C76.9302 8.11057 77.333 8.05192 77.2266 8.03928ZM72.6048 7.93858C72.4963 7.9369 72.2015 7.88221 72.1841 7.9178C72.2912 7.92103 72.5873 7.97409 72.6048 7.93858ZM2.5814 7.9354C2.39584 7.95237 2.80372 7.82841 2.92757 7.81089C2.94054 7.83394 2.59721 7.93398 2.5814 7.9354ZM74.76 7.82358C74.695 7.81493 73.4021 7.77529 73.2197 7.77605C73.398 7.81921 74.6819 7.88192 74.7407 7.86801C74.7577 7.86494 74.7682 7.82545 74.76 7.82358ZM77.5744 7.83552C77.6892 7.79223 77.772 7.83983 77.7872 7.83999C77.9352 7.84311 78.2421 7.82458 78.1789 7.86488C77.9143 7.85884 77.3456 7.92242 77.5744 7.83552ZM72.5152 7.68823C72.0753 7.67292 72.919 7.79657 72.808 7.73144C72.801 7.72773 72.5613 7.69004 72.5152 7.68823ZM74.905 7.81464C75.0005 7.78327 76.3001 7.84459 76.5111 7.83992C76.328 7.90547 76.1731 7.85475 75.9233 7.85447C75.8559 7.85451 75.8756 7.88318 75.8684 7.88312C75.7506 7.88284 75.8369 7.85117 75.7641 7.84952C75.7164 7.85037 74.7715 7.86647 74.905 7.81464ZM77.6394 7.80573C77.708 7.78244 78.5253 7.75168 78.5568 7.75512C78.8081 7.79141 77.7017 7.8163 77.6394 7.80573ZM74.7831 7.74607C74.9211 7.66895 75.5641 7.74626 75.127 7.77262C75.0857 7.77511 74.905 7.73272 74.7831 7.74607ZM72.5633 7.60329C72.541 7.59934 72.0857 7.53946 72.0774 7.56848C72.1415 7.58754 72.8089 7.65413 72.5633 7.60329ZM72.8 7.52343C72.7891 7.52322 72.8949 7.58864 72.6825 7.56372C72.6651 7.56148 72.6318 7.4951 72.3628 7.49404C72.3083 7.49388 72.2233 7.52905 72.2293 7.53232C72.5089 7.66037 73.3503 7.53515 72.8 7.52343ZM77.6503 7.76566C77.6046 7.74542 77.7036 7.68284 77.8019 7.71243C77.8441 7.72505 77.7717 7.76299 77.6503 7.76566ZM71.123 7.43358C71.3887 7.41304 70.5604 7.30512 70.5197 7.31168C70.5431 7.34886 71.0953 7.43639 71.123 7.43358ZM2.89703 7.43937C2.89682 7.43943 2.89661 7.43948 2.8964 7.43954C3.12262 7.38995 2.9951 7.46903 3.00589 7.46747C3.4974 7.39887 3.34679 7.33938 3.41828 7.30802C3.57151 7.24059 3.5756 7.36193 3.8323 7.24135C3.4058 7.4323 3.80298 7.29288 3.8262 7.3302C3.91931 7.48277 3.21374 7.4132 3.0011 7.50846C2.97145 7.52165 3.21334 7.51248 3.13809 7.54902C2.8933 7.66725 2.02906 7.62996 2.89703 7.43937ZM77.8748 7.70591C77.9754 7.67028 78.7737 7.68362 78.5665 7.71704C78.535 7.72379 77.7256 7.76237 77.8748 7.70591ZM39.8783 4.84097C40.0523 4.728 39.5922 4.75482 39.5231 4.82695C39.4888 4.8628 39.8018 4.89054 39.8783 4.84097ZM36.7232 5.32392C36.5015 5.39641 36.3314 5.73656 36.601 5.62022C36.6296 5.60777 36.7584 5.35585 36.7232 5.32392ZM52.666 2.68123C52.3867 2.55915 52.3939 2.74163 52.6022 2.75659C52.6757 2.76222 52.6747 2.68514 52.666 2.68123ZM42.596 4.07181C42.5707 4.07082 42.3002 4.14647 42.3205 4.18683C42.4277 4.18876 42.7598 4.08059 42.596 4.07181ZM52.758 2.6641C52.5877 2.68089 52.8673 2.83675 53.0817 2.73343C52.9771 2.73187 52.7758 2.66229 52.758 2.6641ZM74.2916 7.49061C74.1775 7.52709 73.8457 7.49292 73.6584 7.48657C73.6366 7.42762 74.1571 7.49346 74.2916 7.49061ZM37.7065 5.18995C37.5099 5.3137 37.9809 5.25489 37.9167 5.17349C37.9097 5.16992 37.7141 5.18481 37.7065 5.18995ZM60.8206 4.8325C60.6625 4.8343 61.103 5.05256 61.0004 4.92388C60.9948 4.91831 60.8289 4.8324 60.8206 4.8325ZM62.8162 5.4861C62.712 5.43904 62.2371 5.3028 62.4098 5.40484C62.4368 5.421 62.7986 5.52813 62.8162 5.4861ZM3.41982 7.25972C3.34008 7.21315 3.71038 7.12837 3.76575 7.12525C3.78757 7.12433 3.52377 7.32032 3.41982 7.25972ZM50.7952 2.58567C50.6452 2.598 50.2513 2.58516 50.1853 2.64163C50.3706 2.62121 50.8479 2.68886 50.7952 2.58567ZM38.6801 4.94582C38.4673 4.88102 38.1521 4.97144 38.2656 5.09615C38.6143 4.99912 38.1907 4.97683 38.6801 4.94582ZM53.7111 2.66315C53.5951 2.63821 53.4914 2.75911 53.504 2.76711C53.6235 2.84308 53.8208 2.7314 53.7111 2.66315ZM45.1107 3.43655C45.0909 3.37927 44.7823 3.47714 44.8335 3.50538C44.8503 3.5149 45.1267 3.48287 45.1107 3.43655ZM70.2459 7.05839C70.1075 7.00194 70.539 7.02808 70.6626 7.08654C70.7207 7.1553 70.2644 7.06578 70.2459 7.05839ZM56.8438 3.38107C56.8809 3.30533 56.3168 3.19553 56.5189 3.3224C56.5696 3.35359 56.8315 3.40554 56.8438 3.38107ZM61.4689 4.88271C61.1405 4.87426 62.4078 5.3393 62.0974 5.12549C62.0716 5.11052 61.4998 4.8856 61.4689 4.88271ZM63.5549 5.56876C63.5039 5.54453 63.5797 5.3148 63.7819 5.46806C63.8085 5.48795 63.6594 5.51269 63.6802 5.53363C63.694 5.54667 64.164 5.70963 64.1886 5.70967C64.2137 5.70982 64.2004 5.6272 64.2262 5.62527C64.2557 5.6235 64.5388 5.76776 64.6936 5.80791C64.9867 5.8841 65.0317 5.83038 65.0547 5.8362C65.1241 5.85333 65.2335 5.92609 65.3762 5.96073C66.0942 6.13695 67.2052 6.32938 67.7701 6.5609C67.262 6.41221 66.7655 6.3617 66.2577 6.26599C66.4248 6.17538 65.4948 6.19235 66.0408 6.16759C65.7946 6.15427 63.7197 5.65635 63.5555 5.56892C63.5553 5.56887 63.5551 5.56881 63.5549 5.56876ZM35.8158 5.47662C35.9297 5.3396 35.2272 5.55318 35.1949 5.68452C35.2921 5.6749 35.8014 5.49236 35.8158 5.47662ZM39.0331 4.39182C39.0692 4.37226 39.0894 4.29163 39.1738 4.23118C39.234 4.18809 39.3268 4.15523 39.4814 4.16215C39.4817 4.16207 39.482 4.162 39.4823 4.16192C39.5909 4.16675 39.4868 4.24266 39.5096 4.25534C39.518 4.26069 39.8583 4.28286 39.5992 4.3618C39.2042 4.48251 39.526 4.22399 39.3117 4.27339C39.3031 4.27542 39.256 4.29908 39.1978 4.33053C39.0799 4.39424 38.9167 4.4903 38.9362 4.50217C38.9393 4.5043 39.0555 4.45207 39.0779 4.45696C39.1627 4.4752 39.1406 4.54582 39.152 4.54615C39.1598 4.54595 39.1934 4.53415 39.2427 4.51638C39.4263 4.45004 39.8275 4.3008 39.9184 4.35559C39.9412 4.36918 39.5662 4.49325 39.2599 4.58746C39.0634 4.64783 38.8952 4.6962 38.8778 4.69409C38.8496 4.69073 38.8192 4.51697 38.7883 4.5067C38.7725 4.50154 38.3662 4.66987 38.3078 4.66799C38.2908 4.6674 38.2775 4.66554 38.2676 4.66372C38.3441 4.70059 37.9616 4.79246 37.9589 4.73002C37.9599 4.70484 38.2258 4.6524 38.2362 4.65422C38.2407 4.65492 38.2449 4.65642 38.2486 4.65723C38.1785 4.6057 39.0693 4.38905 38.854 4.34054C39.0995 4.22494 38.8514 4.49027 39.0331 4.39182ZM40.2497 3.98795C40.2273 4.0123 40.205 4.03665 40.1826 4.061C40.6246 3.90906 41.1679 3.8721 41.6897 3.74935C41.8221 3.71836 41.6432 3.64416 41.8241 3.63363C41.9689 3.62523 42.1475 3.69117 42.0773 3.73147C42.0602 3.74142 41.7611 3.74116 41.621 3.78117C41.2076 3.89939 41.3361 3.96896 41.3122 3.97722C41.2859 3.98624 41.0067 3.98198 40.8637 4.01895C40.5043 4.11213 40.3533 4.2092 39.8417 4.25158C40.1114 4.12125 39.9228 4.02339 40.2497 3.98795ZM59.1223 3.9031C59.1553 3.8587 59.4044 4.00424 59.5037 4.03276C59.4714 4.07766 59.224 3.93379 59.1223 3.9031ZM16.5745 3.3128C16.5018 3.40496 17.1804 3.22938 16.9882 3.22444C16.9457 3.22334 16.6593 3.28913 16.5745 3.3128ZM19.6095 2.473C19.6944 2.42696 19.3197 2.48611 19.3341 2.53895C19.3391 2.55585 19.5986 2.479 19.6095 2.473ZM46.135 2.73917C46.1516 2.73234 46.4086 2.69816 46.4177 2.7013C46.6091 2.76586 45.7658 2.89031 46.135 2.73917ZM23.2464 1.24989C22.9471 1.39739 23.8911 1.11916 23.5882 1.14886C23.5732 1.15045 23.2608 1.2428 23.2464 1.24989ZM24.5465 0.81705C24.4725 0.843859 24.1346 0.92664 24.1362 0.950839C24.1391 0.989701 24.5254 0.892898 24.5465 0.81705ZM53.8312 2.32394C53.7995 2.21153 54.3288 2.37615 54.5145 2.39886C54.5436 2.50946 54.0215 2.33716 53.8312 2.32394ZM50.3272 2.02429C52.7126 1.96036 52.1876 2.15825 50.1872 2.08156C50.1801 2.01239 50.1759 2.03416 50.3272 2.02429ZM53.3427 2.19022C53.302 2.21593 53.2268 2.21931 53.1401 2.21341C53.0352 2.20621 52.9133 2.18556 52.8161 2.17281C52.839 2.14431 52.9991 2.15704 53.1437 2.17205C53.2228 2.18018 53.2973 2.18878 53.3427 2.19022ZM15.7449 3.4389C15.8459 3.34548 16.3819 3.27236 16.2965 3.3236C16.2766 3.33516 15.7107 3.48423 15.7449 3.4389ZM46.271 2.61213C46.2017 2.51691 46.7795 2.43572 46.8285 2.44953C47.0262 2.50456 46.3113 2.5788 46.271 2.61213ZM56.9775 2.94009C57.1102 2.89814 57.4212 3.03562 57.6246 3.1036C57.5143 3.13612 57.1534 2.99299 56.9775 2.94009ZM55.47 2.4804C55.4843 2.48005 55.781 2.55732 55.7933 2.56453C56.0216 2.69723 55.1842 2.48058 55.47 2.4804ZM2.45694 7.02261C2.46489 7.01861 2.6565 6.96933 2.66366 6.96946C2.847 6.97271 2.2718 7.12023 2.45694 7.02261Z" fill="url(#paint0_linear_1383_17278)"/>
          <defs>
            <linearGradient id="paint0_linear_1383_17278" x1="2.18431" y1="6.83749" x2="80.2886" y2="6.83749" gradientUnits="userSpaceOnUse">
              <stop stop-color="#D6F901"/>
              <stop offset="1" stop-color="#27DFFB"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
    );

    const itineraryCardDecoSvg = (
      <svg viewBox="0 0 180 72" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#v3ic-flight-clip)">
          <path d="M151.695 25.7995C152.692 27.7648 153.822 29.6777 154.875 31.5461C93.7786 46.9598 39.274 76.8833 0.00013919 104.068C39.4083 74.2183 92.2333 42.637 151.695 25.7995Z" fill="url(#v3ic-flight-a)"/>
          <path d="M176.008 24.9849C176.149 25.3756 176.119 25.8082 175.921 26.1743C174.807 28.2334 173.217 29.5747 170.93 30.3519C168.38 31.2178 165.57 32.033 162.08 32.911C161.928 32.9491 161.854 32.9792 161.847 32.9713C161.834 32.9993 161.807 33.0659 161.772 33.2063C160.58 37.926 159.372 42.5048 158.349 46.3648C158.187 46.9732 157.89 47.8404 157.178 48.3684C156.815 48.6336 156.426 48.8895 155.915 49.1967C155.646 49.3574 155.367 49.5172 155.075 49.685C154.765 49.864 154.441 50.0527 154.094 50.2595C153.634 50.5329 153.061 50.5322 152.601 50.2544C152.141 49.9767 151.869 49.4717 151.895 48.9354L152.62 34.2551C152.18 34.2891 151.743 34.3215 151.309 34.3541C148.882 34.5377 146.588 34.7124 144.233 34.7841C143.683 34.8016 143.321 34.8602 143.152 34.9639C143.038 35.0306 142.944 35.2276 142.876 35.5446C142.742 36.1554 142.495 36.6914 142.276 37.1663C142.125 37.4964 141.981 37.8071 141.904 38.0872C141.447 39.7261 140.326 40.695 138.45 40.9753C138.001 41.0411 137.545 40.8943 137.217 40.5749C136.89 40.254 136.732 39.8002 136.792 39.3464C136.872 38.7239 136.956 38.1109 137.041 37.5015C137.248 36.0012 137.445 34.5835 137.56 33.1553C137.603 32.6348 137.487 32.0069 137.256 31.5144C136.64 30.1829 135.952 28.8889 135.226 27.5192C134.933 26.9653 134.635 26.4055 134.339 25.8368C134.118 25.4159 134.118 24.9155 134.338 24.4968C134.556 24.0763 134.963 23.7911 135.433 23.7307C136.658 23.5701 138.217 23.5897 139.449 25.1684C139.811 25.6302 140.233 26.0679 140.684 26.5317C141.094 26.9558 141.517 27.3935 141.949 27.9101C141.969 27.9028 141.993 27.8957 142.021 27.889C144.163 27.232 146.312 26.5991 148.459 25.9643L149.624 25.6192C150.073 25.4863 150.524 25.3589 150.987 25.2272L145.158 11.8273C144.948 11.3438 145.018 10.7839 145.336 10.3662C145.449 10.2197 145.585 10.097 145.739 10.0065C146.021 9.83779 146.358 9.76624 146.695 9.81612C147.001 9.86165 147.28 9.91032 147.537 9.95719C147.982 10.0361 148.333 10.098 148.633 10.1013C150.695 10.1339 151.774 11.388 152.405 12.3273C153.188 13.4933 154.037 14.6611 154.861 15.7888C156.171 17.5862 157.523 19.4451 158.688 21.4099C159.609 22.9663 160.372 23.2621 162.574 22.9202C165.315 22.4964 168.113 22.6466 170.822 22.7912L171.583 22.8331C172.58 22.8836 173.424 23.295 174.245 23.6971C174.55 23.8441 174.859 23.9986 175.182 24.1272C175.567 24.2808 175.87 24.5908 176.012 24.9815L176.008 24.9849Z" fill="url(#v3ic-flight-b)"/>
        </g>
        <defs>
          <linearGradient id="v3ic-flight-a" x1="26.7015" y1="75.9714" x2="147.599" y2="23.3105" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFECE5"/><stop offset="1" stopColor="#FCD7BB"/>
          </linearGradient>
          <linearGradient id="v3ic-flight-b" x1="179.492" y1="23.3105" x2="135.732" y2="36.6611" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFC1A4"/><stop offset="1" stopColor="#FCDABF"/>
          </linearGradient>
          <clipPath id="v3ic-flight-clip">
            <rect width="185.426" height="59.3362" fill="white" transform="matrix(-0.762045 0.647524 0.647524 0.762045 141.303 -16)"/>
          </clipPath>
        </defs>
      </svg>
    );

    return (
      <>
        {isFixed && (
          <div className="section-nav sticky fixed">
            {[
              { id: "departure-date",    label: "Departure Date" },
              { id: "itinerary-section", label: "Itinerary" },
              { id: "booking-notice",    label: "Booking Notice" },
            ].map(({ id, label }) => (
              <button
                key={id}
                className={`section-nav_tab${activeSection === id ? " active" : ""}`}
                onClick={() => scrollIntoView(id)}
              >
                {label}
              </button>
            ))}
          </div>
        )}

        {itinerary && (
          <div id="itinerary-details">
            <div className="hero">
              <ItineraryImages cover={itinerary.coverImage} images={itinerary.images} />
              <Button
                className="share-btn"
                shape="circle"
                size="small"
                icon={<Icon path={mdiShareVariant} size="18px" color="#DC1A22" />}
                onClick={handleShareLink}
              />
            </div>

            <div className="tour-header">
              {itinerary.isNew && <span className="caption-new-badge new-badge">New</span>}
              <div className="tour-badges">
                <span className="category-badge">{itinerary.category}</span>
                <span className="tour-code">
                  <Icon path={mdiFileDocument} size="14px" />
                  {selectedTour?.code}
                </span>
              </div>
              <h1 ref={v3TitleRef} className={`tour-title${showV3ReadMore ? " expanded" : ""}`}>{selectedTour?.caption}</h1>
              {v3TitleClamped && (
                showV3ReadMore ? (
                  <Button type="link" size="small" className="read-more-btn" onClick={() => setShowV3ReadMore(false)}>Show Less</Button>
                ) : (
                  <Button type="link" size="small" className="read-more-btn" onClick={() => setShowV3ReadMore(true)}>Read More</Button>
                )
              )}
            </div>

            <div className="inclusions-card">
              {/* Coconut tree decoration */}
              <svg className="inclusions-card_deco" aria-hidden="true" viewBox="0 0 111 88" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#v3ic-clip)">
                  <path d="M144 55.1468C138.807 40.9528 129.78 37.3149 123.236 36.7222L138.983 34.6103C129.155 25.7036 120.452 32.3595 116.947 35.9211L121.358 21.3003C113.093 24.8772 113.527 31.6702 114.695 35.7331C111.211 32.9488 103.407 29.9715 90.8496 42.306L109.895 39.144C99.3225 43.2679 98.7011 57.0097 98.7011 57.0097L114.228 41.8114C111.067 48.22 108.049 56.8793 105.437 65.5556L108.107 67.0968L104.341 69.2714C99.7627 85.142 96.6709 99.9983 96.6709 99.9983H106.825C107.464 94.6143 108.068 89.7131 108.64 85.2487L104.746 82.9996L109.272 80.3864C110.538 70.7871 111.629 63.4556 112.558 57.8565L110.676 56.7693L112.966 55.4466C114.837 44.6313 115.985 41.2762 116.551 40.2465L124.868 59.3655C124.868 59.3655 126.995 49.0871 123.708 42.5837L143.996 55.1468H144Z" fill="url(#v3ic-ga)" fillOpacity="0.5"/>
                  <path d="M92.8715 60.0195C88.2422 47.3684 80.196 44.1252 74.3629 43.5968L88.398 41.7135C79.6373 33.7756 71.8806 39.7083 68.7566 42.882L72.6883 29.8498C65.3228 33.0372 65.7088 39.0935 66.7502 42.7144C64.8893 41.2274 61.6468 39.6812 56.9396 41.0411C55.7815 35.5166 52.5034 26.2509 43.3363 22.6741L67.5375 26.6913C51.5823 11.0171 41.6651 14.7989 37.2373 18.3385C38.7223 13.1747 39.2726 4.54414 28.7712 -0.00146484L34.3741 18.5756C29.9209 14.0503 18.8625 5.59417 6.37498 16.9108L26.3821 19.5951C18.0684 20.3505 6.59848 24.9723 0 43.0074L25.781 27.0452C21.6055 35.3083 24.3079 48.3676 24.3079 48.3676L34.877 24.0747C35.5966 25.3838 37.0561 29.6466 39.4317 43.3884L42.3424 45.0702L39.9499 46.4522C41.13 53.5669 42.5151 62.8834 44.1253 75.0807L49.8755 78.4018L44.9279 81.2589C45.6543 86.9325 46.4213 93.1598 47.2341 100H60.1381C60.1381 100 60.0501 99.5768 59.8825 98.7961C60.3989 94.4689 60.8899 90.4958 61.3573 86.8529L57.8862 84.8493L61.9194 82.5206C63.0488 73.9646 64.0207 67.429 64.8487 62.438L63.1707 61.4693L65.2127 60.2905C66.8805 50.6506 67.9033 47.6597 68.4078 46.7418L75.8224 63.7827C75.8224 63.7827 77.7172 54.6204 74.7896 48.8249L92.8749 60.0229L92.8715 60.0195ZM37.8283 26.063L54.2102 42.0979C51.8803 43.2191 49.2575 45.0228 46.3367 47.7664C43.6919 39.7303 40.8117 32.1091 37.8283 26.063ZM58.4991 69.2987L60.8798 70.6739L57.5238 72.6114C56.8008 75.1179 56.1201 77.594 55.4885 79.9752C54.0476 74.2068 52.3256 67.6543 50.392 60.9578L45.6069 58.1955L49.0001 56.236C48.2094 53.611 47.3899 50.9859 46.545 48.4015L62.4714 45.7578C53.0469 49.4346 52.4932 61.6826 52.4932 61.6826L66.3336 48.1339C63.5144 53.8464 60.8256 61.5641 58.4974 69.2987H58.4991Z" fill="url(#v3ic-gb)" fillOpacity="0.5"/>
                </g>
                <defs>
                  <linearGradient id="v3ic-ga" x1="117.425" y1="21.3003" x2="117.425" y2="99.9983" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFDAB1"/>
                    <stop offset="1" stopColor="#FFEBD5"/>
                  </linearGradient>
                  <linearGradient id="v3ic-gb" x1="46.4374" y1="-0.00146484" x2="46.4374" y2="100" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFDAB1"/>
                    <stop offset="1" stopColor="#FFEBD5"/>
                  </linearGradient>
                  <clipPath id="v3ic-clip">
                    <rect width="144" height="100" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
              {/* Radial glow (bottom-right) */}
              <div className="inclusions-card_header">
                <span className="inclusions-card_label">What's Included</span>
                <Button type="link" size="small" className="view-all-btn" onClick={() => setShowV3InclusionsDrawer(true)}>
                  View all
                </Button>
              </div>
              <div className="inclusions-card_list">
                {tourInclusives.filter(i => i.visible && !i.desktopOnly).slice(0, 4).map((item, idx) => (
                  <div key={idx} className="inclusions-card_item">
                    <span className="inclusions-card_item-icon">{item.icon}</span>
                    <div className="inclusions-card_item-body">
                      <span className="inclusions-card_item-label">{item.label}</span>
                      {item.content && !item.tooltip && (
                        <span className="inclusions-card_item-sub">{item.content()}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {selectedTour?.highlight_customer && (
              <div className="highlight-section page-section">
                <div className="highlight-card">
                  <img
                    className="highlight-card_icon"
                    src="/iceholidays-assets/images/v3/highlight-icon.svg"
                    alt=""
                    aria-hidden="true"
                  />
                  <div className="highlight-card_header">
                    <div className="highlight-card_title">
                      <span className="highlight-section_label">Highlight</span>
                      {highlightWavySvg}
                    </div>
                    <Button
                      type="link"
                      size="small"
                      className="highlight-card_view-all"
                      onClick={() => setShowHighlightDrawer(true)}
                    >
                      View all
                    </Button>
                  </div>
                  <div className="highlight-body">
                    <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                      {selectedTour.highlight_customer}
                    </Markdown>
                  </div>
                </div>
              </div>
            )}

            <div id="departure-date" className="page-section">
              <span className="section-label">Departure Date</span>
              <TourDateSelectorV3
                dates={dates ?? []}
                selectedDate={hasCabinNavigation ? (cruiseDeparture?.departure_date || "") : selectedDate}
                selectedTourCode={hasCabinNavigation ? cruiseDeparture?.departure_date : selectedTour?.code}
                selectTour={({date, code, id}) => hasCabinNavigation ? selectCruiseDeparture(date) : getItinerary(date, type, code, id)}
                category={hasCabinNavigation ? CRUISE_CATEGORY : (itinerary.category || "")}
                isNew={!!itinerary.isNew}
                isLoading={tourLoading}
              />
              {!tourLoading && (
                <FlightScheduleV3
                  flights={selectedTour?.flights ?? []}
                  guaranteedDeparture={selectedTour?.guaranteed_departure}
                  arrowLeft={flightArrowLeft}
                />
              )}
              {/* Price banner — hidden only when no price exists at all */}
              {!tourLoading && selectedTour && (
                <PromoBannerV3
                  priceCurrency={itinerary.priceCurrency}
                  promoPrice={promoPrice}
                  normalPrice={normalPrice}
                  basePrice={basePrice}
                  onClick={() => setShowPriceChart(true)}
                />
              )}
              {hasCabinNavigation && (
                <CruiseCabinSelectorV3
                  departure={cruiseDeparture}
                  priceCurrency={itinerary.priceCurrency || "MYR"}
                  selectedMultiplier={cruiseMultiplier}
                  selectedTourId={cruiseTourId}
                  onSelectRoomType={selectCruiseRoomType}
                  onSelectCabin={selectCruiseCabin}
                  cabinSelectionDisabled={cruiseTourDetailLoading}
                />
              )}
            </div>

            {/* Itinerary section — hidden when no URLs exist */}
            {(itinerary.fileUrl || itinerary.fileCNUrl) && (
              <div id="itinerary-section" className="page-section">
                <span className="section-label">Itinerary</span>
                {itinerary.fileUrl && itinerary.fileCNUrl ? (
                  <div className="itinerary-card-group">
                    <div
                      className="itinerary-card"
                      role="button"
                      tabIndex={0}
                      onClick={() => window.open(itinerary.fileUrl, "_blank")}
                      onKeyDown={(e) => { if (e.key === "Enter") window.open(itinerary.fileUrl, "_blank"); }}
                    >
                      <div className="itinerary-card_mini-deco">
                        {itineraryCardDecoSvg}
                      </div>
                      <div className="itinerary-card_left">
                        <div className="itinerary-card_icon"><IconDocument /></div>
                        <span className="itinerary-card_label">English</span>
                      </div>
                      <Icon className="itinerary-card_right-icon" path={mdiChevronRight} size="24px" color="#1E1E1E" />
                    </div>
                    <div
                      className="itinerary-card"
                      role="button"
                      tabIndex={0}
                      onClick={() => window.open(itinerary.fileCNUrl, "_blank")}
                      onKeyDown={(e) => { if (e.key === "Enter") window.open(itinerary.fileCNUrl, "_blank"); }}
                    >
                      <div className="itinerary-card_mini-deco">
                        {itineraryCardDecoSvg}
                      </div>
                      <div className="itinerary-card_left">
                        <div className="itinerary-card_icon"><IconDocument /></div>
                        <span className="itinerary-card_label">Chinese</span>
                      </div>
                      <Icon className="itinerary-card_right-icon" path={mdiChevronRight} size="24px" color="#1E1E1E" />
                    </div>
                  </div>
                ) : (
                  <div
                    className="itinerary-card itinerary-card--single"
                    role="button"
                    tabIndex={0}
                    onClick={() => window.open(itinerary.fileUrl || itinerary.fileCNUrl, "_blank")}
                    onKeyDown={(e) => { if (e.key === "Enter") window.open(itinerary.fileUrl || itinerary.fileCNUrl, "_blank"); }}
                  >
                    <div className="itinerary-card_mini-deco">
                      {itineraryCardDecoSvg}
                    </div>
                    <div className="itinerary-card_left">
                      <div className="itinerary-card_icon"><IconDocument /></div>
                      <span className="itinerary-card_label">{itinerary.fileUrl ? "English" : "Chinese"}</span>
                    </div>
                    <Icon className="itinerary-card_right-icon" path={mdiChevronRight} size="24px" color="#1E1E1E" />
                  </div>
                )}
              </div>
            )}

            <div id="booking-notice" className="page-section">
              <span className="section-label">Booking Notice</span>
              <BookingNoticeTab removeHeader={true} grouped={true} />
            </div>
          </div>
        )}

        <div className="bottom-bar">
          {selectedTour?.departure_date ? (
            <div className="bottom-bar_info">
              <span className="bottom-bar_date">Departure Date: {safeFormatDate(selectedTour.departure_date)}</span>
              <span className="bottom-bar_price">{basePrice}</span>
              <small className="bottom-bar_note">(incl. taxes & fees)</small>
            </div>
          ) : (
            <div className="bottom-bar_info bottom-bar_info--placeholder">
              <span>Select Departure Date</span>
            </div>
          )}
          <Button
            type="primary"
            size="large"
            className="bottom-bar_btn"
            disabled={!selectedTour?.departure_date}
            onClick={() => setShowV3BookingFlow(true)}
          >
            Next
          </Button>
        </div>

        {/* V3 Mobile Only - What's Included — full list drawer */}
        <div className="v3">
          <Drawer
            title={<span className="section-label">What's Included</span>}
            placement="bottom"
            height="100%"
            closable
            open={showV3InclusionsDrawer}
            onClose={() => setShowV3InclusionsDrawer(false)}
            className="inclusions-drawer"
          >
            {/* Palm tree watermark */}
            <svg className="inclusions-drawer_deco" aria-hidden="true" viewBox="0 0 111 88" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#v3id-clip)">
                <path d="M144 55.1468C138.807 40.9528 129.78 37.3149 123.236 36.7222L138.983 34.6103C129.155 25.7036 120.452 32.3595 116.947 35.9211L121.358 21.3003C113.093 24.8772 113.527 31.6702 114.695 35.7331C111.211 32.9488 103.407 29.9715 90.8496 42.306L109.895 39.144C99.3225 43.2679 98.7011 57.0097 98.7011 57.0097L114.228 41.8114C111.067 48.22 108.049 56.8793 105.437 65.5556L108.107 67.0968L104.341 69.2714C99.7627 85.142 96.6709 99.9983 96.6709 99.9983H106.825C107.464 94.6143 108.068 89.7131 108.64 85.2487L104.746 82.9996L109.272 80.3864C110.538 70.7871 111.629 63.4556 112.558 57.8565L110.676 56.7693L112.966 55.4466C114.837 44.6313 115.985 41.2762 116.551 40.2465L124.868 59.3655C124.868 59.3655 126.995 49.0871 123.708 42.5837L143.996 55.1468H144Z" fill="url(#v3id-ga)" fillOpacity="0.5"/>
                <path d="M92.8715 60.0195C88.2422 47.3684 80.196 44.1252 74.3629 43.5968L88.398 41.7135C79.6373 33.7756 71.8806 39.7083 68.7566 42.882L72.6883 29.8498C65.3228 33.0372 65.7088 39.0935 66.7502 42.7144C64.8893 41.2274 61.6468 39.6812 56.9396 41.0411C55.7815 35.5166 52.5034 26.2509 43.3363 22.6741L67.5375 26.6913C51.5823 11.0171 41.6651 14.7989 37.2373 18.3385C38.7223 13.1747 39.2726 4.54414 28.7712 -0.00146484L34.3741 18.5756C29.9209 14.0503 18.8625 5.59417 6.37498 16.9108L26.3821 19.5951C18.0684 20.3505 6.59848 24.9723 0 43.0074L25.781 27.0452C21.6055 35.3083 24.3079 48.3676 24.3079 48.3676L34.877 24.0747C35.5966 25.3838 37.0561 29.6466 39.4317 43.3884L42.3424 45.0702L39.9499 46.4522C41.13 53.5669 42.5151 62.8834 44.1253 75.0807L49.8755 78.4018L44.9279 81.2589C45.6543 86.9325 46.4213 93.1598 47.2341 100H60.1381C60.1381 100 60.0501 99.5768 59.8825 98.7961C60.3989 94.4689 60.8899 90.4958 61.3573 86.8529L57.8862 84.8493L61.9194 82.5206C63.0488 73.9646 64.0207 67.429 64.8487 62.438L63.1707 61.4693L65.2127 60.2905C66.8805 50.6506 67.9033 47.6597 68.4078 46.7418L75.8224 63.7827C75.8224 63.7827 77.7172 54.6204 74.7896 48.8249L92.8749 60.0229L92.8715 60.0195ZM37.8283 26.063L54.2102 42.0979C51.8803 43.2191 49.2575 45.0228 46.3367 47.7664C43.6919 39.7303 40.8117 32.1091 37.8283 26.063ZM58.4991 69.2987L60.8798 70.6739L57.5238 72.6114C56.8008 75.1179 56.1201 77.594 55.4885 79.9752C54.0476 74.2068 52.3256 67.6543 50.392 60.9578L45.6069 58.1955L49.0001 56.236C48.2094 53.611 47.3899 50.9859 46.545 48.4015L62.4714 45.7578C53.0469 49.4346 52.4932 61.6826 52.4932 61.6826L66.3336 48.1339C63.5144 53.8464 60.8256 61.5641 58.4974 69.2987H58.4991Z" fill="url(#v3id-gb)" fillOpacity="0.5"/>
              </g>
              <defs>
                <linearGradient id="v3id-ga" x1="117.425" y1="21.3003" x2="117.425" y2="99.9983" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#FFDAB1"/>
                  <stop offset="1" stopColor="#FFEBD5"/>
                </linearGradient>
                <linearGradient id="v3id-gb" x1="46.4374" y1="-0.00146484" x2="46.4374" y2="100" gradientUnits="userSpaceOnUse">
                  <stop stopColor="#FFDAB1"/>
                  <stop offset="1" stopColor="#FFEBD5"/>
                </linearGradient>
                <clipPath id="v3id-clip">
                  <rect width="144" height="100" fill="white"/>
                </clipPath>
              </defs>
            </svg>
            <div className="inclusions-drawer_body">
              <Flex vertical gap={10}>
                {tourInclusives.filter(i => i.visible).map((item, idx) => (
                  <div
                    key={idx}
                    className={`inclusion-row${item.tooltip ? " inclusion-row--clickable" : ""}`}
                    onClick={item.tooltip ? () => { setV3TooltipItem(item); setShowV3TooltipDrawer(true); } : undefined}
                  >
                    <div className="inclusion-row_icon">{item.icon}</div>
                    <div className="inclusion-row_text">
                      <span className="inclusion-row_label">{item.label}</span>
                      {item.content && <div className="inclusion-row_content">{item.content()}</div>}
                    </div>
                    {item.tooltip && <Icon path={mdiChevronRight} size="16px" color="#888" />}
                  </div>
                ))}
              </Flex>
            </div>
          </Drawer>

          <Drawer
            title={<span className="section-label">{v3TooltipItem?.label}</span>}
            placement="bottom"
            height={v3TooltipItem?.label === "Important Notice" ? "80%" : "50%"}
            closable
            open={showV3TooltipDrawer}
            onClose={() => setShowV3TooltipDrawer(false)}
            rootClassName="nested-drawer nested-drawer--nested"
          >
            <div className="nested-drawer_body">
              {v3TooltipItem?.tooltip}
            </div>
          </Drawer>

          <Drawer
            title={<span className="section-label">Highlight</span>}
            placement="bottom"
            height="100%"
            closable
            open={showHighlightDrawer}
            onClose={() => setShowHighlightDrawer(false)}
            rootClassName="highlight-drawer"
          >
            <div className="highlight-drawer_body">
              <img
                className="highlight-drawer_icon"
                src="/iceholidays-assets/images/v3/highlight-icon.svg"
                alt=""
                aria-hidden="true"
              />
              <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                {selectedTour?.highlight_customer ?? ""}
              </Markdown>
            </div>
          </Drawer>

          <Drawer
            title={<span className="section-label">Price Details</span>}
            placement="bottom"
            height="70%"
            closable
            open={showPriceChart}
            onClose={() => setShowPriceChart(false)}
            rootClassName="price-details-drawer"
          >
            <div style={{ padding: "0px 20px" }}>
              <PriceChartV3
                priceCurrency={itinerary.priceCurrency || "MYR"}
                prices={selectedTour?.prices || []}
                roomTypes={selectedTour?.room_types}
              />
            </div>
          </Drawer>
        </div>
      </>
    );
  }

  return (
    <div className={layoutVersion !== "v1" ? layoutVersion : ""}>
      <div id="show-page">
        <Spin spinning={loading && !isMobile} tip="Loading itinerary..." fullscreen/>

        { loading && isMobile ? <ShowPageSkeleton /> : (layoutVersion === "v3" ? V3Layout() : layoutVersion === "v2" ? V2Layout() : OriginalLayout()) }

        <Drawer
          placement="bottom"
          width="100%"
          height="100%"
          open={layoutVersion === "v3" && showV3BookingFlow}
          onClose={() => setShowV3BookingFlow(false)}
          closable={false}
          destroyOnClose={false}
          className="booking-drawer"
          styles={{ body: { padding: 0, overflowX: 'hidden' } }}
        >
          {itinerary && selectedTour && (
            <BookingFormV3
              itinerary={itinerary}
              selectedTour={selectedTour}
              agents={allAgents}
              agentsLoading={agentsLoading}
              paymentMethods={paymentMethods}
              open={showV3BookingFlow}
              isLoading={tourLoading}
              selectTour={({date, code, id}) => hasCabinNavigation ? selectCruiseDeparture(date) : getItinerary(date, type, code, id)}
              onClose={() => setShowV3BookingFlow(false)}
              promotionDeductions={promotionDeductions}
              promotionTotal={promotionTotal}
              promotionCalcLoading={promotionCalcLoading}
              onPaxItemsChange={(items, tourId) => setV3Pax({ tourId: Number(tourId) || null, items })}
              isCruise={hasCabinNavigation}
              cruiseDeparture={cruiseDeparture}
              cruiseMultiplier={cruiseMultiplier}
              cruiseCabinType={cruiseCabinType}
              cruiseTourId={cruiseTourId}
              cruiseCabins={cruiseCabins}
              setCruiseCabins={setCruiseCabins}
              cruiseCabinGroups={cruiseCabinGroups}
              onSelectCruiseRoomType={selectCruiseRoomType}
              onSelectCruiseCabin={selectCruiseCabin}
            />
          )}
        </Drawer>


        <Modal title={<img src={agentData?.image}/>} open={isModalOpen} onCancel={closeModal} footer={null} width={325} centered className="agent-full-contact-details" zIndex={1200}>
          <h2> {agentData?.name} </h2>
          <div className="contact-details">
            <Row gutter={[15, 15]} align="middle">
              <Col span={24}>
                <Icon path={mdiMapMarker} size="15px" />
                <span>{agentData?.address}</span>
              </Col>
              <Col xs={24} sm={24} lg={6}>
                <Icon path={mdiPhoneInTalkOutline} size="15px" />
                <span>{agentData?.phone}</span>
              </Col>
              <Col xs={24} sm={24} lg={6}>
                <Icon path={mdiWhatsapp} size="15px" />
                <span>{agentData?.whatsapp}</span>
              </Col>
              <Col xs={24} sm={24} lg={9}>
                <Icon path={mdiEmailOutline} size="15px" />
                <span>{agentData?.email}</span>
              </Col>
            </Row>
          </div>
        </Modal>

        <Drawer
          title={<div className="inclusion-drawer-title">
            <span className="inclusion-drawer-title__icon">{selectedInclusion?.icon}</span>
            <span className="inclusion-drawer-title__label">{selectedInclusion?.label}</span>
            <Button type="text" className="inclusion-drawer-close" icon={<Icon path={mdiClose} size="30px" />} onClick={() => setIsInclusionModalOpen(false)} />
          </div>}
          placement="right"
          onClose={() => setIsInclusionModalOpen(false)}
          open={isInclusionModalOpen}
          width="100%"
          closable={false}
        >
          <div>
            {typeof selectedInclusion?.tooltip === 'string' ? (
              <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                {selectedInclusion.tooltip}
              </Markdown>
            ) : (
              selectedInclusion?.tooltip
            )}
          </div>
        </Drawer>
      </div>
    </div>
  );
};

export default ShowPage;
